import React, { Component } from 'react'
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock'
import { isMobile, isBrowser } from 'react-device-detect'
import { PARTY_COLORS } from '../../constants/colors'
import { partyOrderLowercase } from '../../constants/partyOrder.js'
import Img from 'react-image'
import _ from 'lodash'
import './styles.scss'
import { FilterComponent } from 'components/filter/component'
import { ListComponent } from 'components/list/component'
import { OverlayComponent } from 'components/overlay/component'
import { LocaleContext } from 'contexts/locale'

type Props = {
  data: string[]
  sr: string[]
  nr: string[]
  council: string
}

type State = {
  activeId: number
  activeCouncil: string
  showTooltip: boolean
  showOverlay: boolean
  touchPos: string[]
  circleOffset: number
  circleRadius: number
  latestTouch: number
  textFilterIsActive: boolean
  locale: string[]
  globalLocale: string[]
  seatAmount: number
  touchMoves: number
  touchMovesThreshold: number
  filterIsActive: boolean
}

export class SVGComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showTooltip: false,
      showOverlay: false,
      activeId: -1,
      activeCouncil: 'nr',
      circleOffset: 70,
      circleRadius: 15,
      lastestTouch: 0,
      textFilterIsActive: false,
      seatAmount: 0,
      touchMoves: 0,
      touchMovesThreshold: 25,
      touchPos: {
        x: 50,
        y: 50
      },
      locale: [],
      globalLocale: [],
      filterIsActive: false
    }
    this.changeActiveSeat = this.changeActiveSeat.bind(this)
    this.showOverlay = this.showOverlay.bind(this)
    this.startTapMoveGesture = this.startTapMoveGesture.bind(this)
    this.endTapMoveGesture = this.endTapMoveGesture.bind(this)
    this.applyTextFilter = this.applyTextFilter.bind(this)
    this.escapeName = this.escapeName.bind(this)
    this.politicianHandler = this.politicianHandler.bind(this)
    this.freezeBody = this.freezeBody.bind(this)
    this.applyDropdownFilter = this.applyDropdownFilter.bind(this)
  }

  componentWillMount() {
    const locale = this.context
    const messages = require('./locales/' + locale + '.yml')
    const globalMessages = require('locales/' + locale + '.yml')
    this.setState({
      locale: messages,
      globalLocale: globalMessages
    })
  }

  getBirthday(date) {
    if (!date) {
      return '?'
    }
    const day = date.split('.')[0]
    const month = date.split('.')[1]
    const year = date.split('.')[2]

    const today = new Date()
    const birthDate = new Date(year + '-' + month + '-' + day)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  politicianHandler(direction) {
    /* Get all seats that are not transparent */
    const allActivePoliticians = document.querySelectorAll(
      'svg#' + this.props.council + ' path:not(.inactive)[data-name]'
    )

    const allVisiblePoliticians = []
    const allVisiblePoliticiansObjects = []
    for (let i = 0; i < allActivePoliticians.length; i++) {
      allVisiblePoliticians.push(
        parseInt(allActivePoliticians[i].getAttribute('id').substr(2))
      )
      allVisiblePoliticiansObjects.push({
        party: allActivePoliticians[i].getAttribute('data-party'),
        seat: parseInt(allActivePoliticians[i].getAttribute('id').substr(2))
      })
    }

    const sortedObject = allVisiblePoliticiansObjects.sort(
      (a, b) =>
        partyOrderLowercase.indexOf(a.party) -
        partyOrderLowercase.indexOf(b.party)
    )

    console.log(sortedObject)
    // console.log(_.min(allVisiblePoliticians), _.max(allVisiblePoliticians))
    // console.log(this.state.activeId);

    const theSortedList = []
    for (let i = 0; i < sortedObject.length; i++) {
      theSortedList.push(parseInt(sortedObject[i].seat))
    }

    let nextId

    if (direction === 'next') {
      nextId = this.state.activeId + 1
      while (theSortedList.indexOf(nextId) < 0) {
        if (nextId >= this.state.seatAmount) {
          nextId = _.min(theSortedList)
        } else {
          nextId++
        }
      }
    } else {
      nextId = this.state.activeId - 1
      while (theSortedList.indexOf(nextId) < 0) {
        if (nextId < 1) {
          nextId = _.max(theSortedList)
        } else {
          nextId--
        }
      }
    }

    const nextPossibleSeat = this.props.council + nextId
    // console.log(nextPossibleSeat);

    /* Change seat in state here */

    this.changeActiveSeat(
      null,
      // this.props.council + '' + nex,
      nextPossibleSeat,
      null,
      null,
      true
    )
  }

  changeActiveSeat(
    e,
    seatIdentification,
    el,
    highlightSeat,
    ignoreOpenOverlay
  ) {
    let seatId = -1
    if (seatIdentification) {
      seatId = seatIdentification
      if (highlightSeat) {
        const allPaths = document.querySelectorAll(
          'svg#' + this.props.council + ' path[data-name]'
        )
        for (let i = 0; i < allPaths.length; i++) {
          /* Remove active class */
          allPaths[i].classList = ''
          /* Set active class for matching seat */
          if (allPaths[i].getAttribute('id') === seatIdentification) {
            allPaths[i].classList = 'active'
          } else {
            allPaths[i].classList = 'inactive'
          }
        }
      }
    } else {
      // console.log(e.currentTarget.classList)
      if (e.currentTarget.classList.value === 'inactive') {
        // return
      }
      seatId = e.currentTarget.getAttribute('id')
    }
    const councilType = seatId.substring(0, 2)
    const seatNumber = parseInt(seatId.substring(2))
    if (this.state.showOverlay && !ignoreOpenOverlay) {
      return
    }
    this.setState({
      showTooltip: !this.state.showOverlay,
      activeId: seatNumber,
      activeCouncil: councilType
    })
  }

  escapeName(str) {
    // Replace all weird chars
    const escapedString = str
      .replace(/ä/gi, 'a')
      .replace(/à/gi, 'a')
      .replace(/â/gi, 'a')
      .replace(/ö/gi, 'o')
      .replace(/ô/gi, 'o')
      .replace(/ü/gi, 'u')
      .replace(/û/gi, 'u')
      .replace(/ù/gi, 'u')
      .replace(/é/gi, 'e')
      .replace(/è/gi, 'e')
      .replace(/ê/gi, 'e')
      .replace(/ë/gi, 'e')
      .replace(/ç/gi, 'c')
      .replace(/ï/gi, 'i')
      .replace(/î/gi, 'i')
      .replace(/ /g, '')
      .replace(/'/g, '')
    return escapedString
  }

  freezeBody(freeze) {
    if (freeze) {
      disableBodyScroll(document.querySelector('#app'))
      document.querySelector('#app').style = 'overflow: hidden;'
    } else {
      enableBodyScroll(document.querySelector('#app'))
      document.querySelector('#app').style = 'overflow: auto;'
    }
  }

  showOverlay(e: string, enforced: boolean) {
    this.freezeBody(false)
    if (e.srcElement) {
      if (e.srcElement.classList.contains('inactive') && !enforced) return
    }
    if (isMobile && e.type === 'click' && !enforced) {
      this.freezeBody(false)
      return
    }
    // if (this.state.showTooltip) {
    if (isMobile) {
      // this.freezeBody(true)
    }

    this.setState({
      showOverlay: true,
      showTooltip: false
    })
    // };
  }

  startTapMoveGesture() {
    this.setState({
      touchMoves: parseInt(this.state.touchMoves) + 1
    })

    const svg = document.querySelector(`svg#${this.props.council}`)
    const NS = svg.getAttribute('xmlns')
    let svgP

    /* UNCOMMENT THIS TO RE-ENABLE THRESHOLD */
    /*
      if (this.state.touchMoves < this.state.touchMovesThreshold) {
        this.freezeBody(false);
      }
   */

    /* Freeze body */
    this.freezeBody(true)

    /* Bind event listener */
    // console.log(this.state.touchMoves);

    if (!this.state.textFilterIsActive) {
      svg.addEventListener(
        'touchmove',
        e => {
          const pt = svg.createSVGPoint()
          let circle

          /* Two finger touch option */
          /*
          if (e.touches.length < 2) {
            console.log(e.touches)
            return
          }
           */

          /* Freeze body */
          // document.querySelector('#app').style = 'overflow: hidden;'
          // disableBodyScroll(document.querySelector('#app'))
          // document.querySelector('body').addEventListener('touchstart', e => e.preventDefault());

          pt.x = e.touches[0].clientX
          pt.y = e.touches[0].clientY - this.state.circleOffset
          svgP = pt.matrixTransform(svg.getScreenCTM().inverse())

          /* Move circle when touch moves */
          const touchCircle = document.querySelector(
            `circle#${this.props.council}circle`
          )
          // Only set circle pos if inside visible SVG area
          if (
            svg.height.baseVal.value - this.state.circleRadius > svgP.y &&
            svgP.y > this.state.circleRadius &&
            svg.width.baseVal.value - this.state.circleRadius > svgP.x &&
            svgP.x > this.state.circleRadius
          ) {
            touchCircle.setAttributeNS(null, 'cx', svgP.x)
            touchCircle.setAttributeNS(null, 'cy', svgP.y)
            // touchCircle.setAttributeNS(null, 'r', 17);
            touchCircle.setAttributeNS(null, 'opacity', 1)
          } else {
            // Reduce opacity to show you're at the border with the circle
            touchCircle.setAttributeNS(null, 'opacity', 0.5)
          }
        },
        false
      )
    }
  }

  endTapMoveGesture() {
    /* Log end gesture */
    if (isMobile) {
      this.setState({
        latestTouch: new Date().getTime()
      })
    }
    this.setState({
      touchMoves: 0
    })
    /* Store circle pos */
    const circlePos = {
      x: document
        .querySelector(`circle#${this.props.council}circle`)
        .getAttribute('cx'),
      y: document
        .querySelector(`circle#${this.props.council}circle`)
        .getAttribute('cy')
    }

    this.setState({
      showTooltip: false
    })

    /* Make circle smaller again */
    /* const touchCircle = document.querySelector(
      `circle#${this.props.council}circle`
    ) */
    // touchCircle.setAttributeNS(null, 'r', 12)
    // touchCircle.setAttributeNS(null, 'opacity', 1)
    /* Loop through all path elements to find matching BBOX */
    /* Only select active paths so not when filter is active and stuff */
    const allPaths = document.querySelectorAll(
      'svg#' + this.props.council + ' path:not(.inactive)[data-name]'
    )
    for (let i = 0; i < allPaths.length; i++) {
      /* Remove active class */
      // allPaths[i].classList = '';
      /* Gets BBox of the path */
      const bbox = allPaths[i].getBBox()
      /* Comparing if touch pos x and y match the BBox */
      if (circlePos.x < bbox.x || circlePos.x > bbox.x + bbox.width) {
        continue
      } else if (circlePos.y < bbox.y || circlePos.y > bbox.y + bbox.height) {
        continue
      } else {
        this.changeActiveSeat(null, allPaths[i].getAttribute('id'))
      }
    }
    /* Unfreeze body */
    this.freezeBody(false)
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks()
  }

  componentDidMount() {
    // Loop through all NR to colour them, amount absolute = 200
    if (this.props.council === 'nr') {
      /* Add event listener to nr svg */
      const svgElement = document.querySelector('svg#nr')
      if (svgElement !== null && isMobile) {
        svgElement.addEventListener('touchmove', e =>
          this.startTapMoveGesture(e)
        )
        svgElement.addEventListener('touchend', e => this.endTapMoveGesture())
      }

      const seatedMembers = this.props.nr.filter(el => el.Sitznummer)

      /* Set seat amounts to loop through later */
      this.setState({
        seatAmount: this.props.nr.length
      })

      for (let i = 0; i < seatedMembers.length; i++) {
        /* Colour */
        const seatNumber = parseInt(seatedMembers[i].Sitznummer)
        const el = document.querySelector('path#nr' + seatNumber)
        const fillColor = PARTY_COLORS[seatedMembers[i].Partei]
        const nameTag =
          seatedMembers[i].Vorname + ' ' + seatedMembers[i].Nachname
        el.setAttribute('data-name', nameTag || 'no name')
        el.setAttribute('data-party', seatedMembers[i].Partei.toLowerCase())
        el.setAttribute('data-canton', seatedMembers[i].Kanton.toLowerCase())
        el.setAttribute(
          'data-gender',
          seatedMembers[i].Geschlecht.toLowerCase()
        )
        if (this.context === 'de') {
          if (
            seatedMembers[i].Geschlecht.toLowerCase() === 'm' ||
            seatedMembers[i].Kanton.toLowerCase() !== 'zh' ||
            seatedMembers[i].Vorname === ''
          ) {
            el.classList = 'inactive'
          }
        } else {
          if (
            seatedMembers[i].Geschlecht.toLowerCase() === 'm' ||
            ['vd', 'ge'].indexOf(seatedMembers[i].Kanton.toLowerCase()) < 0 ||
            seatedMembers[i].Vorname === ''
          ) {
            el.classList = 'inactive'
          }
        }
        /* Event listeners */
        setTimeout(function() {
          el.style = 'fill: ' + fillColor
        }, i * 5)
        if (!isMobile) {
          el.addEventListener('mouseenter', e =>
            this.changeActiveSeat(e, null, el)
          )
          el.addEventListener('mouseleave', () =>
            this.setState({ showTooltip: false })
          )
          if (seatedMembers[i].Elected === 'Ja') {
            el.addEventListener('click', e => this.showOverlay(e, false))
          }
        } else {
          el.style = 'pointer-events: none;'
        }
      }
    }
    // Loop through all SR to colour them, amount absolute = 46
    else if (this.props.council === 'sr') {
      /* Add event listener to nr svg */
      const svgElement = document.querySelector('svg#sr')
      if (svgElement !== null && isMobile) {
        svgElement.addEventListener('touchmove', e =>
          this.startTapMoveGesture(e)
        )
        svgElement.addEventListener('touchend', e => this.endTapMoveGesture())
      }

      const seatedMembers = this.props.sr.filter(el => el.Sitznummer)

      /* Set seat amounts to loop through later */
      this.setState({
        seatAmount: this.props.sr.length
      })

      for (let i = 0; i < seatedMembers.length; i++) {
        /* Colour */
        const el = document.querySelector(
          'path#sr' + seatedMembers[i].Sitznummer
        )
        const fillColor = PARTY_COLORS[seatedMembers[i].Partei]
        const nameTag =
          seatedMembers[i].Vorname + ' ' + seatedMembers[i].Nachname
        el.setAttribute('data-name', nameTag)
        el.setAttribute('data-party', seatedMembers[i].Partei.toLowerCase())
        el.setAttribute('data-canton', seatedMembers[i].Kanton.toLowerCase())
        el.setAttribute(
          'data-gender',
          seatedMembers[i].Geschlecht.toLowerCase()
        )
        if (
          seatedMembers[i].Geschlecht.toLowerCase() === 'w' ||
          seatedMembers[i].Vorname === ''
        ) {
          el.classList = 'inactive'
        }
        setTimeout(function() {
          el.style = 'fill: ' + fillColor
        }, i * 5)
        /* Event listeners */
        if (isBrowser) {
          el.addEventListener('mouseenter', e =>
            this.changeActiveSeat(e, null, el)
          )
          if (seatedMembers[i].Elected === 'Ja') {
            el.addEventListener('click', e => this.showOverlay(e, false))
          }
          el.addEventListener('mouseleave', () =>
            this.setState({ showTooltip: false })
          )
        } else {
          el.style = 'pointer-events: none;'
          // el.addEventListener('touchstart', e => this.changeActiveSeat(e))
        }
      }
    }
  }

  applyDropdownFilter(val, additionalFilters) {
    /* Select all relevant paths */
    const allPaths = document.querySelectorAll(
      'svg#' + this.props.council + ' path[data-name]'
    )

    /* Check if any options set in dropdown */
    if (!val) {
      for (let i = 0; i < allPaths.length; i++) {
        /* Remove all classes */
        allPaths[i].classList = ''
      }
      return
    } else {
      const allFilterItemsByTpe = _.groupBy(val, el => el.type)
      const amountOfFilterCategoriesSet = Object.keys(allFilterItemsByTpe)
        .length
      // console.log('Categories set: ' + amountOfFilterCategoriesSet)

      for (let i = 0; i < allPaths.length; i++) {
        /* allPaths[i] is the current politician */
        const gender = allPaths[i].getAttribute('data-gender')
        const canton = allPaths[i].getAttribute('data-canton')
        const party = allPaths[i].getAttribute('data-party')
        const name = allPaths[i].getAttribute('data-name')
        // Set const for JSON.stringify of all stuff searchable in custom filter

        let amountOfPointsAchieved = 0

        /* Check for gender */
        if (gender && gender !== '') {
          if (
            _.find(
              allFilterItemsByTpe.gender,
              val => val.value[0] === gender
            ) !== undefined
          ) {
            amountOfPointsAchieved++
          }
        }

        /* See if party matches */
        if (party && party !== '') {
          if (
            _.find(allFilterItemsByTpe.party, val => val.value[0] === party) !==
            undefined
          ) {
            amountOfPointsAchieved++
          }
        }

        /* See if party matches */
        if (canton && canton !== '') {
          if (
            _.find(
              allFilterItemsByTpe.canton,
              val => val.value[0] === canton
            ) !== undefined
          ) {
            amountOfPointsAchieved++
          }
        }

        /* Additional filtering for custom tags */
        if (additionalFilters) {
          /* Find the matching data */
          const currentSearchItem = _.find(
            this.props[this.props.council],
            el => el.Vorname + ' ' + el.Nachname === name
          )
          // const currentSearchItem = this.props[this.props.council].filter(el => el.Vorname + ' ' + el.Nachname === name);
          if (currentSearchItem) {
            const searchString = JSON.stringify(
              currentSearchItem.Nachname +
                ' ' +
                currentSearchItem.Vorname +
                ' ' +
                this.state.globalLocale.UI.Global.Parties[
                  currentSearchItem.Partei
                ] +
                ' ' +
                this.state.globalLocale.UI.Global.Cantons[
                  currentSearchItem.Kanton
                ] +
                ' ' +
                currentSearchItem.Geburtsdatum +
                ' ' +
                currentSearchItem['Wohnort ' + this.context] +
                ' ' +
                currentSearchItem.Kanton +
                ' ' +
                currentSearchItem['Beruf ' + this.context] +
                ' ' +
                currentSearchItem['DabeiSeit ' + this.context] +
                ' ' +
                currentSearchItem['Text ' + this.context] +
                ' ' +
                this.getBirthday(currentSearchItem.Geburtsdatum) +
                ' ' +
                this.state.globalLocale.UI.Global.Gender[
                  currentSearchItem.Geschlecht
                ]
            )

            const pointsUntilNow = amountOfPointsAchieved
            const filtersSetUntilNow = amountOfFilterCategoriesSet
            let additionalFiltersMatch = 0

            for (let ii = 0; ii < additionalFilters.length; ii++) {
              const re = new RegExp(
                _.escapeRegExp(additionalFilters[ii].value),
                'i'
              )
              if (searchString.search(re) > 0) {
                additionalFiltersMatch++
                console.log(additionalFiltersMatch, additionalFilters.length)
              }
            }

            if (
              additionalFilters &&
              additionalFiltersMatch === additionalFilters.length
            ) {
              amountOfPointsAchieved++
            }
          }
        }

        if (amountOfPointsAchieved >= amountOfFilterCategoriesSet) {
          allPaths[i].classList = ''
        } else {
          allPaths[i].classList = 'inactive'
        }
      }
    }

    this.setState({
      textFilterIsActive: false,
      showTooltip: false,
      showOverlay: false
    })
  }

  applyTextFilter(val, Vorname, Nachname) {
    // get ID from first and lastname from paths
    if (val < 0) {
      const allPaths = document.querySelectorAll(
        'svg#' + this.props.council + ' path[data-name]'
      )
      for (let i = 0; i < allPaths.length; i++) {
        /* Remove active class */
        allPaths[i].classList = ''
        /* Check if all values match the current politician */
        // console.log(allPaths[i].getAttribute('data-name'))
      }
      this.setState({
        textFilterIsActive: false,
        showTooltip: false
      })
      if (isMobile) {
        // Select circle
        const touchCircle = document.querySelector(
          `circle#${this.props.council}circle`
        )
        // Show circle
        touchCircle.setAttributeNS(null, 'opacity', 1)
      }
      return
    } else if (val === null) {
      // Blur all Inputs to hide keyboard on iOS
      const allInputElements = document.querySelectorAll('input')
      for (let i = 0; i < allInputElements.length; i++) {
        allInputElements[i].blur()
      }
      // Find id by Vorname and Nachname, looping the paths..
      const allPaths = document.querySelectorAll(
        'svg#' + this.props.council + ' path[data-name]'
      )
      for (let i = 0; i < allPaths.length; i++) {
        // console.log(allPaths[i].getAttribute('data-name'))
        if (
          allPaths[i].getAttribute('data-name') ===
          Vorname + ' ' + Nachname
        ) {
          val = allPaths[i].getAttribute('id').substr(2)
          // console.log('***VAL*** ' + val)
        }
      }
    }
    if (isMobile) {
      const touchCircle = document.querySelector(
        `circle#${this.props.council}circle`
      )
      touchCircle.setAttributeNS(null, 'cx', 50)
      touchCircle.setAttributeNS(null, 'cy', 50)
      touchCircle.setAttributeNS(null, 'opacity', 0)
    }
    this.setState({
      textFilterIsActive: true
    })
    this.changeActiveSeat(null, this.props.council + '' + val, null, true)
  }

  render() {
    const {
      activeCouncil,
      touchPos,
      latestTouch,
      textFilterIsActive
    } = this.state
    const { council } = this.props

    let currentPolitician = {
      Nachname: 'a',
      Vorname: 'b',
      Partei: 'c'
    }

    if (this.state.activeId > 0) {
      if (
        this.props[activeCouncil].filter(
          el => parseInt(el.Sitznummer) === parseInt(this.state.activeId)
        )
      ) {
        currentPolitician = this.props[activeCouncil].filter(
          el => parseInt(el.Sitznummer) === parseInt(this.state.activeId)
        )[0]
      }
      // console.log(this.props[activeCouncil].filter(el => parseInt(el.Sitznummer) === parseInt(this.state.activeId)))
      // currentPolitician = this.props[activeCouncil][this.state.activeId - 1]
    }

    const ImagePlaceholder = showLoader => (
      <div className='ui avatar image'>
        <Img
          src={require('./transparent.png')}
          style={{
            opacity: showLoader ? 0.5 : 1,
            width: '100%',
            backgroundColor: PARTY_COLORS[currentPolitician.Partei]
          }}
        />
        {showLoader && <div className='ui active small inverted loader' />}
      </div>
    )

    return (
      <div className={`svg-container ${isMobile ? 'is-mobile' : 'is-desktop'}`}>
        {council === 'nr' && (
          <div>
            <FilterComponent
              setFilterState={bool => this.setState({ filterIsActive: bool })}
              council={council}
              data={this.props.nr}
              update={isMobile ? latestTouch : null}
              updateHandler={this.applyTextFilter}
              dropdownHandler={this.applyDropdownFilter}
            />
            <div
              className={`ui center aligned text container tooltip-container ${
                !this.state.showTooltip ? '' : 'white'
              }`}
            >
              {!this.state.showTooltip ? (
                <div className='call-to-action'>
                  <div className='slide-in-bck-center'>
                    {isMobile ? (
                      <span>
                        {this.state.locale.SVGComponent.CallToAction.Mobile}
                      </span>
                    ) : (
                      <span>
                        {this.state.locale.SVGComponent.CallToAction.Desktop}
                      </span>
                    )}
                  </div>
                </div>
              ) : (
                <div className='politician-preview'>
                  <div
                    className='slide-in-bck-center'
                    onClick={e =>
                      this.showOverlay(e, currentPolitician.Elected === 'Ja')
                    }
                  >
                    {currentPolitician.Elected === 'Ja' ? (
                      <div className='flex-parent'>
                        <Img
                          src={`https://interaktiv.tagesanzeiger.ch/imageUpload/interaktives-parlament/${this.escapeName(
                            currentPolitician.Nachname
                          )}_${this.escapeName(currentPolitician.Vorname)}.png`}
                          className='ui avatar image'
                          style={{
                            backgroundColor:
                              PARTY_COLORS[currentPolitician.Partei]
                          }}
                          loader={ImagePlaceholder(true)}
                          unloader={ImagePlaceholder(false)}
                        />
                        <div className='slide-in-bck-center'>
                          <span style={{ fontWeight: 800 }}>
                            {currentPolitician.Vorname}{' '}
                            {currentPolitician.Nachname}
                            {'  '}
                          </span>
                          {currentPolitician['Funktion ' + this.context] && (
                            <span style={{ fontWeight: 400 }}>
                              , {currentPolitician['Funktion ' + this.context]}
                            </span>
                          )}
                          <br />
                          {
                            this.state.globalLocale.UI.Global.Parties[
                              currentPolitician.Partei
                            ]
                          }{' '}
                          {
                            this.state.globalLocale.UI.Global.Cantons[
                              currentPolitician.Kanton
                            ]
                          }
                        </div>
                        {isMobile && (
                          <a
                            style={{
                              paddingLeft: '1rem',
                              fontSize: '0.8rem',
                              alignSelf: 'flex-end'
                            }}
                            className='shake-left'
                          >
                            {
                              this.state.locale.SVGComponent.CallToAction
                                .Portrait[1]
                            }
                            <i className='ui icon chevron right' />
                          </a>
                        )}
                        {textFilterIsActive && !isMobile && (
                          <a
                            style={{
                              paddingLeft: '1rem',
                              fontSize: '0.8rem',
                              alignSelf: 'flex-end'
                            }}
                            className='shake-left'
                          >
                            {
                              this.state.locale.SVGComponent.CallToAction
                                .Portrait[0]
                            }
                            <i className='ui icon chevron right' />
                          </a>
                        )}
                      </div>
                    ) : (
                      <div className='flex-parent'>
                        <div className='slide-in-bck-center'>
                          <span style={{ fontWeight: 400, lineHeight: 2 }}>
                            {currentPolitician['Funktion ' + this.context]}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div
              id={`dropbox-${council}`}
              className={`dropbox ${isMobile ? 'grey' : ''} ${
                this.state.touchMoves > 0 ? 'active' : ''
              }`}
            >
              <svg
                id='nr'
                width='950px'
                height='704px'
                viewBox='0 0 950 704'
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                xmlnsXlink='http://www.w3.org/1999/xlink'
                style={{
                  width: '100%',
                  height: 'auto',
                  pointerEvents: textFilterIsActive ? 'none' : 'auto'
                }}
              >
                <filter id='dropshadow' x='-2' y='-2' width='200' height='200'>
                  <feGaussianBlur stdDeviation='1' />
                </filter>
                <rect />
                <g
                  id='parliament-nr'
                  stroke='none'
                  strokeWidth='1'
                  fill='none'
                  fillRule='evenodd'
                >
                  <path
                    d='M409,675.3 L393.6,675.3 C391.8,675.3 390.4,673.9 390.4,672.1 L390.4,649.2 C390.4,647.4 391.8,646 393.6,646 L409,646 C410.8,646 412.2,647.4 412.2,649.2 L412.2,672.1 C412.2,673.9 410.8,675.3 409,675.3 Z'
                    id='nr212'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M328.4,648.6 C328.6,646.9 330.3,645.5 331.5,645.8 L347.4,646.9 C349.1,647 350.4,648.7 350.1,649.9 L347.7,672.6 C347.5,674.3 345.8,675.7 344.6,675.4 L328.7,674.3 C327,674.2 325.7,672.5 326,671.3 L328.4,648.6 Z'
                    id='nr211'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M293.9,641.5 C294.2,640 296.1,638.7 297.4,639.2 L313.2,642.4 C314.7,642.7 316,644.5 315.5,645.9 L311,668.5 C310.7,670 308.8,671.3 307.5,670.8 L291.7,667.6 C290.2,667.3 288.9,665.5 289.4,664.1 L293.9,641.5 Z'
                    id='nr210'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M674.7,580.8 C674.4,579.3 672.3,578.4 670.9,578.8 L655.9,583.8 C654.4,584.1 653.5,586.2 654,587.5 L661.7,609.2 C662,610.7 664.1,611.6 665.5,611.2 L680.5,606.2 C682,605.9 682.9,603.8 682.4,602.5 L674.7,580.8 Z'
                    id='nr209'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M646.4,590.3 C646.1,588.8 644.2,587.5 642.9,588 L627.1,591.2 C625.6,591.5 624.3,593.3 624.8,594.7 L629.3,617.3 C629.6,618.8 631.5,620.1 632.8,619.6 L648.6,616.4 C650.1,616.1 651.4,614.3 650.9,612.9 L646.4,590.3 Z'
                    id='nr208'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M614.5,596.4 C614.3,594.7 612.6,593.3 611.4,593.6 L595.5,594.7 C593.8,594.8 592.5,596.5 592.8,597.7 L595.2,620.4 C595.4,622.1 597.1,623.5 598.3,623.2 L614.2,622.1 C615.9,622 617.2,620.3 616.9,619.1 L614.5,596.4 Z'
                    id='nr207'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M484.9,624.9 L469.5,624.9 C467.7,624.9 466.3,623.5 466.3,621.7 L466.3,598.8 C466.3,597 467.7,595.6 469.5,595.6 L484.9,595.6 C486.7,595.6 488.1,597 488.1,598.8 L488.1,621.7 C488.2,623.5 486.7,624.9 484.9,624.9 Z'
                    id='nr206'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M439.4,624.9 L424,624.9 C422.2,624.9 420.8,623.5 420.8,621.7 L420.8,598.8 C420.8,597 422.2,595.6 424,595.6 L439.4,595.6 C441.2,595.6 442.6,597 442.6,598.8 L442.6,621.7 C442.6,623.5 441.1,624.9 439.4,624.9 Z'
                    id='nr205'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M409,624.9 L393.6,624.9 C391.8,624.9 390.4,623.5 390.4,621.7 L390.4,598.8 C390.4,597 391.8,595.6 393.6,595.6 L409,595.6 C410.8,595.6 412.2,597 412.2,598.8 L412.2,621.7 C412.2,623.5 410.8,624.9 409,624.9 Z'
                    id='nr204'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M333.4,596.6 C333.6,594.9 335.3,593.5 336.5,593.8 L352.4,594.9 C354.1,595 355.4,596.7 355.1,597.9 L352.7,620.6 C352.5,622.3 350.8,623.7 349.6,623.4 L333.7,622.3 C332,622.2 330.7,620.5 331,619.3 L333.4,596.6 Z'
                    id='nr203'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M302.9,590.5 C303.2,589 305.1,587.7 306.4,588.2 L322.2,591.4 C323.7,591.7 325,593.5 324.5,594.9 L320,617.5 C319.7,619 317.8,620.3 316.5,619.8 L300.7,616.6 C299.2,616.3 297.9,614.5 298.4,613.1 L302.9,590.5 Z'
                    id='nr202'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M275.3,581.3 C275.6,579.8 277.7,578.9 279.1,579.3 L294.1,584.3 C295.6,584.6 296.5,586.7 296,588 L288.3,609.7 C288,611.2 285.9,612.1 284.5,611.7 L269.5,606.7 C268,606.4 267.1,604.3 267.6,603 L275.3,581.3 Z'
                    id='nr201'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M918.4,293 C919.7,292.4 921.7,292.8 922.4,294.3 L929.7,308.6 C930.4,309.9 929.9,311.8 928.4,312.5 L907.6,322.4 C906.3,323 904.3,322.6 903.6,321.1 L896.3,306.8 C895.6,305.5 896.1,303.6 897.6,302.9 L918.4,293 Z'
                    id='nr200'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M462,53.9 C462,55.5 460.8,57.2 459.1,57.2 L443.7,57.6 C442.2,57.6 440.6,56.3 440.6,54.5 L440,31.5 C440,29.9 441.2,28.2 442.9,28.2 L458.3,27.8 C459.8,27.8 461.4,29.1 461.4,30.9 L462,53.9 Z'
                    id='nr199'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M903.5,266 C905,265.4 907,265.8 907.6,267.1 L915.7,280.5 C916.4,282 915.9,283.9 914.6,284.5 L894.5,295.4 C893,296 891,295.6 890.4,294.3 L882.3,280.9 C881.6,279.4 882.1,277.5 883.4,276.9 L903.5,266 Z'
                    id='nr198'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M432,55.6 C432.2,57.1 430.9,58.8 429.5,59 L414,60.7 C412.5,60.9 410.8,59.6 410.6,58.1 L408,35.9 C407.8,34.4 409.1,32.7 410.5,32.5 L426,30.8 C427.5,30.6 429.2,31.9 429.4,33.4 L432,55.6 Z'
                    id='nr197'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M885.3,237.3 C886.6,236.2 888.8,236.9 889.5,238 L898.5,251.4 C899.6,252.7 898.9,254.9 897.8,255.6 L878.7,268.3 C877.4,269.4 875.2,268.7 874.5,267.6 L865.5,254.2 C864.4,252.9 865.1,250.7 866.2,250 L885.3,237.3 Z'
                    id='nr196'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M403,60 C403.2,61.6 402.3,63.3 400.6,63.5 L384.6,66.6 C383,66.8 381.3,65.9 381.1,64.2 L377.1,41.4 C376.9,39.8 377.8,38.1 379.5,37.9 L395.5,34.8 C397.1,34.6 398.8,35.5 399,37.2 L403,60 Z'
                    id='nr195'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M865.7,212.4 C867,211.3 869,211.8 869.9,212.8 L879.4,225.6 C880.5,226.9 880.1,228.8 879,229.7 L860.4,243.1 C859.1,244.2 857.1,243.7 856.2,242.7 L846.7,229.9 C845.6,228.6 846,226.7 847.1,225.8 L865.7,212.4 Z'
                    id='nr194'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M371,65.3 C371.2,66.8 370.6,68.6 368.7,69 L353.7,72.7 C352.2,72.9 350.5,72.3 350.1,70.3 L345,48.1 C344.8,46.6 345.4,44.8 347.3,44.4 L362.3,40.7 C363.8,40.5 365.5,41.1 365.9,43.1 L371,65.3 Z'
                    id='nr193'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M845.8,187.5 C847.1,186.4 849.1,186.4 850,187.7 L860.2,199.8 C861.3,201.1 861.3,203 860,203.8 L842.2,218 C840.9,219.1 838.9,219.1 838,217.8 L827.8,205.7 C826.7,204.4 826.7,202.5 828,201.7 L845.8,187.5 Z'
                    id='nr192'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M341.9,72.6 C342.3,74.1 341.5,75.8 339.9,76.3 L324.6,80.6 C323.1,81 321.3,80.2 320.9,78.7 L314.1,56.9 C313.7,55.4 314.5,53.7 316.1,53.2 L331.4,48.9 C332.9,48.5 334.7,49.3 335.1,50.8 L341.9,72.6 Z'
                    id='nr191'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M824.3,163.6 C825.4,162.3 827.6,162.5 828.5,163.6 L840,175.1 C841.3,176.2 841.1,178.4 840,179.3 L823.4,195.7 C822.3,197 820.1,196.8 819.2,195.7 L807.9,183.9 C806.6,182.8 806.8,180.6 807.9,179.7 L824.3,163.6 Z'
                    id='nr190'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M311.9,80.5 C312.3,82 311.7,83.7 310.2,84.3 L295.7,89.6 C294.2,90 292.5,89.4 291.9,87.9 L284.2,66.9 C283.8,65.4 284.4,63.7 285.9,63.1 L300.4,57.8 C301.9,57.4 303.6,58 304.2,59.5 L311.9,80.5 Z'
                    id='nr189'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M772.6,152.2 C771.5,153.5 772,155.5 773,156.4 L785.6,166.1 C786.9,167.2 788.8,166.8 789.7,165.7 L803.3,147.4 C804.4,146.1 803.9,144.1 802.9,143.2 L790.3,133.5 C789,132.4 787.1,132.8 786.2,133.9 L772.6,152.2 Z'
                    id='nr188'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M283.7,91.7 C284.4,93.2 283.7,94.9 282.2,95.6 L267.5,101.6 C266,102 264.2,101.6 263.5,100.1 L254.3,79.8 C253.6,78.3 254.3,76.6 255.8,75.9 L270.5,69.9 C272,69.5 273.8,69.9 274.5,71.4 L283.7,91.7 Z'
                    id='nr187'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M746.4,134 C745.7,135.3 746,137.2 747.1,138 L760.6,146.4 C761.9,147 763.9,146.8 764.8,145.8 L777.7,127.5 C778.4,126.2 778.1,124.3 777,123.5 L763.5,115.1 C762.2,114.5 760.2,114.7 759.3,115.7 L746.4,134 Z'
                    id='nr186'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M255.7,104 C256.3,105.5 255.9,107.3 254.4,108 L240.4,115.5 C238.9,116.2 237.2,115.7 236.5,114.2 L226.2,93.5 C225.6,92 226,90.2 227.5,89.5 L241.5,82 C243,81.3 244.7,81.8 245.4,83.3 L255.7,104 Z'
                    id='nr185'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M721.3,119.1 C720.7,120.4 721.1,122.4 722.4,123.3 L735.6,131.4 C736.9,132.1 738.8,131.6 739.6,130.3 L750.7,110.3 C751.3,109 750.9,107 749.6,106.1 L736.4,98 C735.1,97.3 733.2,97.8 732.4,99.1 L721.3,119.1 Z'
                    id='nr184'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M227.7,119.1 C228.3,120.4 227.9,122.4 226.6,123.3 L213.4,131.4 C212.1,132.1 210.2,131.6 209.4,130.3 L198.3,110.3 C197.7,109 198.1,107 199.4,106.1 L212.6,98 C213.9,97.3 215.8,97.8 216.6,99.1 L227.7,119.1 Z'
                    id='nr183'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M693.3,104 C692.7,105.5 693.1,107.3 694.6,108 L708.6,115.5 C710.1,116.2 711.8,115.7 712.5,114.2 L722.8,93.5 C723.4,92 723,90.2 721.5,89.5 L707.5,82 C706,81.3 704.3,81.8 703.6,83.3 L693.3,104 Z'
                    id='nr182'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M202.6,134 C203.3,135.3 203,137.2 201.9,138 L188.4,146.4 C187.1,147 185.1,146.8 184.2,145.8 L171.3,127.5 C170.6,126.2 170.9,124.3 172,123.5 L185.5,115.1 C186.8,114.5 188.8,114.7 189.7,115.7 L202.6,134 Z'
                    id='nr181'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M665.3,91.8 C664.6,93.3 665.3,95 666.8,95.6 L681.5,101.6 C683,102 684.8,101.6 685.5,100.1 L694.7,79.7 C695.4,78.2 694.7,76.5 693.2,75.9 L678.5,69.9 C677,69.5 675.2,69.9 674.5,71.4 L665.3,91.8 Z'
                    id='nr180'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M176.4,152.2 C177.5,153.5 177,155.5 176,156.4 L163.4,166.1 C162.1,167.2 160.2,166.8 159.3,165.7 L145.7,147.4 C144.6,146.1 145.1,144.1 146.1,143.2 L158.7,133.5 C160,132.4 161.9,132.8 162.8,133.9 L176.4,152.2 Z'
                    id='nr179'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M636.1,80.5 C635.7,82 636.3,83.7 637.8,84.3 L652.3,89.6 C653.8,90 655.5,89.4 656.1,87.9 L663.8,66.9 C664.2,65.4 663.6,63.7 662.1,63.1 L647.6,57.8 C646.1,57.4 644.4,58 643.8,59.5 L636.1,80.5 Z'
                    id='nr178'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M142.1,179.8 C143.2,180.9 143.4,183.1 142.1,184 L130.8,195.8 C129.7,196.9 127.5,197.1 126.6,195.8 L110,179.4 C108.9,178.3 108.7,176.1 110,175.2 L121.5,163.7 C122.6,162.6 124.8,162.4 125.7,163.7 L142.1,179.8 Z'
                    id='nr177'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M606.1,72.6 C605.7,74.1 606.5,75.8 608.1,76.3 L623.4,80.6 C624.9,81 626.7,80.2 627.1,78.7 L633.9,56.9 C634.3,55.4 633.5,53.7 631.9,53.2 L616.6,48.9 C615.1,48.5 613.3,49.3 612.9,50.8 L606.1,72.6 Z'
                    id='nr176'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M122,201.7 C123.3,202.8 123.3,204.7 122.2,205.7 L112,217.7 C110.9,219 108.9,219 107.8,217.9 L90,203.8 C88.7,202.7 88.7,200.8 89.8,199.8 L100,187.7 C101.1,186.4 103.1,186.4 104.2,187.5 L122,201.7 Z'
                    id='nr175'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M577,65.3 C576.8,66.8 577.4,68.6 579.3,69 L594.3,72.7 C595.8,72.9 597.5,72.3 597.9,70.3 L603,48.2 C603.2,46.7 602.6,44.9 600.7,44.5 L585.7,40.8 C584.2,40.6 582.5,41.2 582.1,43.2 L577,65.3 Z'
                    id='nr174'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M101.9,225.8 C103.2,226.9 103.4,228.8 102.3,229.9 L92.8,242.6 C91.7,243.9 89.7,244.1 88.6,243 L70.1,229.6 C68.8,228.5 68.6,226.6 69.7,225.5 L79.2,212.8 C80.3,211.5 82.3,211.3 83.4,212.4 L101.9,225.8 Z'
                    id='nr173'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M546,60 C545.8,61.6 546.7,63.3 548.4,63.5 L564.4,66.6 C566,66.8 567.7,65.9 567.9,64.2 L571.9,41.4 C572.1,39.8 571.2,38.1 569.5,37.9 L553.5,34.8 C551.9,34.6 550.2,35.5 550,37.2 L546,60 Z'
                    id='nr172'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M83.7,250 C85,250.7 85.4,253.1 84.4,254.1 L75.4,267.4 C74.7,268.7 72.3,269.1 71.3,268.1 L52.3,255.4 C51,254.7 50.6,252.3 51.6,251.3 L60.6,238 C61.3,236.7 63.7,236.3 64.7,237.3 L83.7,250 Z'
                    id='nr171'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M516,55.6 C515.8,57.1 517.1,58.8 518.5,59 L534,60.7 C535.5,60.9 537.2,59.6 537.4,58.1 L539.9,35.8 C540.1,34.3 538.8,32.6 537.4,32.4 L521.9,30.7 C520.4,30.5 518.7,31.8 518.5,33.3 L516,55.6 Z'
                    id='nr170'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M66.6,276.9 C67.9,277.5 68.3,279.4 67.7,280.9 L59.6,294.3 C58.9,295.6 57,296 55.5,295.4 L35.4,284.5 C34.1,283.9 33.7,282 34.3,280.5 L42.4,267.1 C43.1,265.8 45,265.4 46.5,266 L66.6,276.9 Z'
                    id='nr169'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M487,53.9 C487,55.5 488.2,57.2 489.9,57.2 L505.3,57.6 C506.8,57.6 508.4,56.3 508.4,54.5 L509,31.4 C509,29.8 507.8,28.1 506.1,28.1 L490.7,27.7 C489.2,27.7 487.6,29 487.6,30.8 L487,53.9 Z'
                    id='nr168'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M52.4,303 C53.9,303.6 54.4,305.6 53.7,306.9 L46.4,321.2 C45.7,322.7 43.7,323.1 42.4,322.5 L21.6,312.6 C20.1,312 19.6,310 20.3,308.7 L27.6,294.4 C28.3,292.9 30.3,292.5 31.6,293.1 L52.4,303 Z'
                    id='nr167'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M889.7,475.8 C888.2,476 886.7,477.3 887.1,479.1 L888.6,495.1 C888.8,496.6 890.1,498.1 891.8,497.7 L914.3,495.7 C915.8,495.5 917.3,494.2 916.9,492.4 L915.4,476.4 C915.2,474.9 913.9,473.4 912.2,473.8 L889.7,475.8 Z'
                    id='nr166'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M463,113.9 C463,115.5 461.7,117 460.1,117.2 L444.6,117.6 C443.1,117.6 441.7,116.3 441.5,114.5 L441,91.5 C441,89.9 442.3,88.2 443.9,88.2 L459.4,87.8 C460.9,87.8 462.5,89.1 462.5,90.9 L463,113.9 Z'
                    id='nr165'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M883.5,443.7 C881.9,443.9 880.8,445.5 881.1,447.2 L884.2,463.2 C884.4,464.8 886,465.9 887.7,465.6 L910.5,461.6 C912.1,461.4 913.2,459.8 912.9,458.1 L909.8,442.1 C909.6,440.5 908,439.4 906.3,439.7 L883.5,443.7 Z'
                    id='nr164'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M435,115.6 C435.2,117.1 433.9,118.8 432.4,119 L417,120.7 C415.5,120.9 413.8,119.6 413.6,118.1 L411,95.9 C410.8,94.4 412.1,92.7 413.6,92.5 L429.4,90.8 C430.9,90.6 432.6,91.9 432.8,93.4 L435,115.6 Z'
                    id='nr163'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M876.1,412.8 C874.6,413.2 873.5,414.8 874.2,416.6 L878.1,432.5 C878.5,434.1 880,435.2 881.8,434.5 L903.9,428.7 C905.4,428.3 906.5,426.7 905.8,424.9 L901.9,409 C901.5,407.4 900,406.3 898.2,407 L876.1,412.8 Z'
                    id='nr162'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M406,120 C406.2,121.6 405.3,123.3 403.6,123.5 L387.9,126.6 C386.4,126.8 384.6,125.9 384.4,124.2 L380,101.4 C379.8,99.8 380.7,98.1 382.4,97.9 L398.1,94.8 C399.6,94.6 401.4,95.5 401.6,97.2 L406,120 Z'
                    id='nr161'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M864.9,383.4 C863.4,383.8 862.6,385.7 863.2,387 L868.3,401.8 C868.7,403.3 870.6,404.1 871.9,403.5 L893,396.1 C894.5,395.7 895.3,393.8 894.7,392.5 L889.6,377.7 C889.2,376.2 887.3,375.4 886,376 L864.9,383.4 Z'
                    id='nr160'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M378.9,125 C379.3,126.5 378.5,128.3 377,128.7 L362.1,132.6 C360.6,133 359,132.2 358.5,130.6 L353,108.4 C352.6,106.9 353.4,105.1 354.9,104.7 L369.8,100.8 C371.3,100.4 372.9,101.2 373.4,102.8 L378.9,125 Z'
                    id='nr159'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M852.7,355.3 C851.1,356 850.7,357.7 851.1,359.3 L858,374 C858.7,375.5 860.4,376 862,375.5 L883.3,366 C884.9,365.3 885.3,363.6 884.9,362 L878,347.3 C877.3,345.8 875.6,345.3 874,345.8 L852.7,355.3 Z'
                    id='nr158'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M350.9,133 C351.3,134.5 350.7,136.2 349.2,136.6 L334.1,141.5 C332.6,141.9 330.9,141.3 330.4,139.8 L323.1,118.4 C322.7,116.9 323.3,115.2 324.8,114.8 L339.9,109.9 C341.4,109.5 343.1,110.1 343.6,111.6 L350.9,133 Z'
                    id='nr157'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M838.6,326.6 C837.1,327.2 836.6,329.1 837.3,330.4 L845,344.2 C845.7,345.7 847.6,346.1 849,345.5 L869.4,334.9 C870.9,334.3 871.4,332.4 870.7,331.1 L863,317.3 C862.3,315.8 860.4,315.4 859,316 L838.6,326.6 Z'
                    id='nr156'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M322.9,142.2 C323.3,143.7 322.7,145.4 321.4,146.1 L307.1,151.7 C305.6,152.1 303.9,151.5 303.3,150.2 L295.1,129.4 C294.7,127.9 295.3,126.2 296.6,125.5 L310.9,119.9 C312.4,119.5 314.1,120.1 314.7,121.4 L322.9,142.2 Z'
                    id='nr155'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M822.4,299.5 C821.1,300.2 820.6,302.1 821.3,303.7 L829.9,317.3 C830.6,318.6 832.5,319.1 834.1,318.4 L853.7,305.9 C855,305.2 855.5,303.3 854.8,301.7 L846.2,288.1 C845.5,286.8 843.6,286.3 842,287 L822.4,299.5 Z'
                    id='nr154'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M296.7,153.4 C297.4,155 296.7,156.7 295.4,157.4 L280.9,164.5 C279.4,165.2 277.6,164.5 276.9,163.2 L267.2,142.1 C266.5,140.5 267.2,138.8 268.5,138.1 L283,131 C284.5,130.3 286.3,131 287,132.3 L296.7,153.4 Z'
                    id='nr153'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M804.1,272.8 C802.8,273.9 802.6,275.8 803.7,276.9 L813.1,289.6 C814.2,290.9 816.2,291.1 817.3,290 L835.9,276.6 C837.2,275.5 837.4,273.6 836.3,272.5 L826.9,259.8 C825.8,258.5 823.8,258.3 822.7,259.4 L804.1,272.8 Z'
                    id='nr152'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M268.7,165.5 C269.3,166.8 268.9,168.8 267.6,169.5 L254.2,177.5 C252.9,178.2 251,177.7 250.4,176.4 L239.3,156 C238.7,154.7 239.1,152.7 240.4,152 L253.8,144 C255.1,143.3 257,143.8 257.6,145.1 L268.7,165.5 Z'
                    id='nr151'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M785,247.7 C783.7,248.8 783.7,250.7 784.8,251.7 L795,263.8 C796.1,265.1 798.1,265.1 799.2,264 L816.9,249.8 C818.2,248.7 818.4,246.8 817.1,245.8 L806.9,233.7 C805.8,232.4 803.8,232.4 802.7,233.5 L785,247.7 Z'
                    id='nr150'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M243.6,180.7 C244.3,182 244,184 242.5,184.9 L228.7,193.4 C227.4,194.1 225.4,193.8 224.5,192.3 L212.3,172.8 C211.6,171.5 211.9,169.5 213.4,168.6 L227.4,160.1 C228.7,159.4 230.7,159.7 231.6,161.2 L243.6,180.7 Z'
                    id='nr149'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M763.8,224.2 C762.7,225.3 762.7,227.5 763.8,228.4 L775.3,239.9 C776.4,241 778.6,241 779.5,239.9 L796.1,223.3 C797.2,222.2 797.2,220 796.1,219.1 L784.6,207.6 C783.5,206.5 781.3,206.5 780.4,207.6 L763.8,224.2 Z'
                    id='nr148'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M218.4,197.4 C219.5,198.7 219,200.7 218,201.6 L205.2,211.1 C203.9,212.2 202,211.8 201.1,210.7 L187.7,192.1 C186.6,190.8 187.1,188.8 188.1,187.9 L200.9,178.4 C202.2,177.3 204.1,177.7 205,178.8 L218.4,197.4 Z'
                    id='nr147'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M729.6,197.4 C728.5,198.7 729,200.7 730,201.6 L742.8,211.1 C744.1,212.2 746,211.8 746.9,210.7 L760.3,192.1 C761.4,190.8 760.9,188.8 759.9,187.9 L747.1,178.4 C745.8,177.3 743.9,177.7 743,178.8 L729.6,197.4 Z'
                    id='nr146'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M185.2,224.2 C186.3,225.3 186.3,227.5 185.2,228.4 L173.7,239.9 C172.6,241 170.4,241 169.5,239.9 L152.9,223.3 C151.8,222.2 151.8,220 152.9,219.1 L164.4,207.6 C165.5,206.5 167.7,206.5 168.6,207.6 L185.2,224.2 Z'
                    id='nr145'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M705.4,180.7 C704.7,182 705,184 706.5,184.9 L720.3,193.4 C721.6,194.1 723.6,193.8 724.5,192.3 L736.7,172.8 C737.4,171.5 737.1,169.5 735.6,168.6 L721.8,160.1 C720.5,159.4 718.5,159.7 717.6,161.2 L705.4,180.7 Z'
                    id='nr144'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M164,247.7 C165.3,248.8 165.3,250.7 164.2,251.7 L154,263.7 C152.9,265 150.9,265 149.8,263.9 L132.1,249.7 C130.8,248.6 130.6,246.7 131.9,245.7 L142.1,233.6 C143.2,232.3 145.2,232.3 146.3,233.4 L164,247.7 Z'
                    id='nr143'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M680.3,165.5 C679.7,166.8 680.1,168.8 681.4,169.5 L694.8,177.5 C696.1,178.2 698,177.7 698.6,176.4 L709.7,156.1 C710.3,154.8 709.9,152.8 708.6,152.1 L695.2,144.1 C693.9,143.4 692,143.9 691.4,145.2 L680.3,165.5 Z'
                    id='nr142'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M144.9,272.8 C146.2,273.9 146.4,275.8 145.3,276.9 L135.9,289.6 C134.8,290.9 132.8,291.1 131.7,290 L113.1,276.6 C111.8,275.5 111.6,273.6 112.7,272.5 L122.1,259.8 C123.2,258.5 125.2,258.3 126.3,259.4 L144.9,272.8 Z'
                    id='nr141'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M652.3,153.4 C651.6,155 652.3,156.7 653.6,157.4 L668.1,164.5 C669.6,165.2 671.4,164.5 672.1,163.2 L681.8,142.1 C682.5,140.5 681.8,138.8 680.5,138.1 L666,131 C664.5,130.3 662.7,131 662,132.3 L652.3,153.4 Z'
                    id='nr140'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M126.6,299.5 C127.9,300.2 128.4,302.1 127.7,303.7 L119.1,317.3 C118.4,318.6 116.5,319.1 114.9,318.4 L95.3,305.9 C94,305.2 93.5,303.3 94.2,301.7 L102.8,288.1 C103.5,286.8 105.4,286.3 107,287 L126.6,299.5 Z'
                    id='nr139'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M626.1,142.2 C625.7,143.7 626.3,145.4 627.6,146.1 L641.9,151.7 C643.4,152.1 645.1,151.5 645.7,150.2 L653.9,129.4 C654.3,127.9 653.7,126.2 652.4,125.5 L638.1,119.9 C636.6,119.5 634.9,120.1 634.3,121.4 L626.1,142.2 Z'
                    id='nr138'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M110.4,326.6 C111.9,327.2 112.4,329.1 111.7,330.4 L104,344.2 C103.3,345.7 101.4,346.1 100,345.5 L79.5,334.9 C78.2,334.3 77.5,332.4 78.2,331.1 L85.9,317.3 C86.6,315.8 88.5,315.4 89.9,316 L110.4,326.6 Z'
                    id='nr137'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M597.1,133 C596.7,134.5 597.3,136.2 598.8,136.6 L614,141.5 C615.5,141.9 617.3,141.3 617.7,139.8 L624.9,118.4 C625.3,116.9 624.7,115.2 623.2,114.8 L608,109.9 C606.5,109.5 604.7,110.1 604.3,111.6 L597.1,133 Z'
                    id='nr136'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M96.3,355.3 C97.9,356 98.3,357.7 97.9,359.3 L91,374 C90.3,375.5 88.6,376 87,375.5 L65.7,366 C64.1,365.3 63.7,363.6 64.1,362 L71,347.3 C71.7,345.8 73.4,345.3 75,345.8 L96.3,355.3 Z'
                    id='nr135'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M571.1,125 C570.7,126.5 571.5,128.3 573,128.7 L587.9,132.6 C589.4,133 591,132.2 591.5,130.6 L597,108.4 C597.4,106.9 596.6,105.1 595.1,104.7 L580.2,100.8 C578.7,100.4 577.1,101.2 576.6,102.8 L571.1,125 Z'
                    id='nr134'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M84.1,383.4 C85.6,383.8 86.4,385.7 85.8,387 L80.7,401.8 C80.3,403.3 78.4,404.1 77.1,403.5 L55.9,396.1 C54.4,395.7 53.6,393.8 54.2,392.5 L59.3,377.7 C59.7,376.2 61.6,375.4 62.9,376 L84.1,383.4 Z'
                    id='nr133'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M543,120 C542.8,121.6 543.7,123.3 545.4,123.5 L561.2,126.6 C562.7,126.8 564.5,125.9 564.7,124.2 L568.9,101.4 C569.1,99.8 568.2,98.1 566.5,97.9 L550.7,94.8 C549.2,94.6 547.4,95.5 547.2,97.2 L543,120 Z'
                    id='nr132'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M72.9,412.8 C74.4,413.2 75.5,414.8 74.8,416.6 L70.9,432.5 C70.5,434.1 69,435.2 67.2,434.5 L45.1,428.7 C43.6,428.3 42.5,426.7 43.2,424.9 L47.1,409 C47.5,407.4 49,406.3 50.8,407 L72.9,412.8 Z'
                    id='nr131'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M514,115.6 C513.8,117.1 515.1,118.8 516.6,119 L532,120.7 C533.5,120.9 535.2,119.6 535.4,118.1 L538,95.8 C538.2,94.3 536.9,92.6 535.4,92.4 L519.6,90.7 C518.1,90.5 516.4,91.8 516.2,93.3 L514,115.6 Z'
                    id='nr130'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M65.5,443.7 C67.1,443.9 68.2,445.5 67.9,447.2 L64.8,463.2 C64.6,464.8 63,465.9 61.3,465.6 L38.5,461.6 C36.9,461.4 35.8,459.8 36.1,458.1 L39.2,442.1 C39.4,440.5 41,439.4 42.7,439.7 L65.5,443.7 Z'
                    id='nr129'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M485,113.9 C485,115.5 486.3,117 487.9,117.2 L503.4,117.6 C504.9,117.6 506.5,116.3 506.5,114.5 L506.9,91.4 C506.9,89.8 505.6,88.1 504,88.1 L488.5,87.7 C487,87.7 485.6,89 485.4,90.8 L485,113.9 Z'
                    id='nr128'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M59.3,475.8 C60.8,476 62.3,477.3 61.9,479.1 L60.4,495.1 C60.2,496.6 58.9,498.1 57.2,497.7 L34.7,495.7 C33.2,495.5 31.7,494.2 32.1,492.4 L33.6,476.4 C33.8,474.9 35.1,473.4 36.8,473.8 L59.3,475.8 Z'
                    id='nr127'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M825.7,475.8 C824.2,476 822.7,477.3 823.1,479.1 L824.6,495.1 C824.8,496.6 826.1,498.1 827.8,497.7 L850.3,495.7 C851.8,495.5 853.3,494.2 852.9,492.4 L851.4,476.4 C851.2,474.9 849.9,473.4 848.2,473.8 L825.7,475.8 Z'
                    id='nr126'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M466,174.8 C466,176.3 465,178.1 463.1,178.1 L447.7,178.8 C446.2,178.8 444.6,177.5 444.6,175.7 L444,152.8 C444,151.3 445,149.5 446.9,149.5 L462.3,148.8 C463.8,148.8 465.4,150.1 465.4,151.9 L466,174.8 Z'
                    id='nr125'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M819.4,445.6 C817.9,445.8 816.8,447.3 817,449.2 L820.5,464.3 C820.7,465.8 822.3,466.9 824.2,466.6 L846.5,461.7 C848,461.5 849.1,460 848.9,458.1 L845.4,443 C845.2,441.5 843.6,440.4 841.7,440.7 L819.4,445.6 Z'
                    id='nr124'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M439,176.4 C439.2,177.9 438,179.6 436.5,179.8 L421.5,181.7 C420,181.9 418.4,181.1 418.2,179.2 L415.1,157.1 C414.9,155.6 415.7,153.9 417.6,153.7 L432.6,151.8 C434.1,151.6 435.7,152.4 435.9,154.3 L439,176.4 Z'
                    id='nr123'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M810.9,418.2 C809.4,418.6 808.6,420.1 809.2,421.8 L814.3,436.8 C814.7,438.3 816.2,439.2 817.9,438.5 L839.1,431.2 C840.6,430.8 841.4,428.8 840.8,427.6 L835.7,412.6 C835.3,411.1 833.8,410.2 832.1,410.9 L810.9,418.2 Z'
                    id='nr122'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M413,180.9 C413.2,182.4 412.3,184.2 410.6,184.4 L394.9,187.7 C393.4,187.9 391.6,187 391.4,185.3 L387,162.6 C386.8,161.1 387.7,159.3 389.4,159.1 L405.1,155.8 C406.6,155.6 408.4,156.5 408.6,158.2 L413,180.9 Z'
                    id='nr121'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M801.8,390.1 C800.3,390.5 799.5,392.5 800.3,394.1 L806,408.9 C806.4,410.4 808.3,411.3 809.8,410.4 L830.2,401.4 C831.7,401 832.5,399 831.7,397.4 L826,382.6 C825.6,381.1 823.7,380.2 822.2,381.1 L801.8,390.1 Z'
                    id='nr120'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M386.9,185.8 C387.3,187.3 386.5,189.1 384.9,189.5 L369,193.6 C367.4,194 365.6,193.2 365.2,191.6 L359.2,169.6 C358.8,168.1 359.6,166.3 361.2,165.9 L377.1,161.8 C378.7,161.4 380.5,162.2 380.9,163.8 L386.9,185.8 Z'
                    id='nr119'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M787.6,363 C786.1,363.7 785.6,365.6 786.3,366.9 L793.6,381.1 C794.3,382.6 796.3,383.1 797.6,382.4 L818.4,372.4 C819.9,371.7 820.4,369.8 819.7,368.5 L812.4,354.3 C811.7,352.8 809.7,352.3 808.4,353 L787.6,363 Z'
                    id='nr118'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M359.9,193.5 C360.3,195 359.7,196.7 358.2,197.3 L343.7,202.6 C342.2,203 340.5,202.4 339.9,200.9 L332.2,179.9 C331.8,178.4 332.4,176.7 333.9,176.1 L348.4,170.8 C349.9,170.4 351.6,171 352.2,172.5 L359.9,193.5 Z'
                    id='nr117'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M772.4,337.4 C771.1,338 770.7,339.9 771.3,341.4 L779.8,354.4 C780.5,355.7 782.4,356.1 783.9,355.5 L803.6,344.2 C804.9,343.6 805.3,341.7 804.7,340.2 L796.2,327.2 C795.5,325.9 793.6,325.5 792.1,326.1 L772.4,337.4 Z'
                    id='nr116'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M334.7,202.7 C335.4,204.3 334.7,206 333.2,206.7 L318.5,213.6 C317,214 315.2,213.6 314.5,212 L305.3,190.7 C304.6,189.1 305.3,187.4 306.8,186.7 L321.5,179.8 C323,179.4 324.8,179.8 325.5,181.4 L334.7,202.7 Z'
                    id='nr115'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M756.2,312.3 C754.9,313.4 754.7,315.4 755.5,316.4 L764.8,329.5 C765.9,330.8 767.9,331 769,330.2 L787.8,317.1 C789.1,316 789.3,314 788.5,313 L779.2,299.9 C778.1,298.6 776.1,298.4 775,299.2 L756.2,312.3 Z'
                    id='nr114'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M308.7,214.9 C309.3,216.4 308.9,218.2 307.4,218.9 L293.6,226.4 C292.1,227.1 290.4,226.6 289.8,225.1 L279.2,204.5 C278.6,203 279,201.2 280.5,200.5 L294.3,193 C295.8,192.3 297.5,192.8 298.1,194.3 L308.7,214.9 Z'
                    id='nr113'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M738.1,289.4 C736.8,290.5 736.6,292.4 737.7,293.4 L747.6,305.7 C748.7,307 750.7,307.2 751.8,306.1 L769.9,292.2 C771.2,291.1 771.4,289.2 770.3,288.2 L760.4,275.9 C759.3,274.6 757.3,274.4 756.2,275.5 L738.1,289.4 Z'
                    id='nr112'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M284.6,227.7 C285.3,229 285,231 283.5,231.9 L269.7,240.4 C268.4,241.1 266.4,240.8 265.5,239.3 L253.3,219.8 C252.6,218.5 252.9,216.5 254.4,215.6 L267.9,207.1 C269.2,206.4 271.2,206.7 272.1,208.2 L284.6,227.7 Z'
                    id='nr111'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M719,267.7 C717.7,268.8 717.7,271 719,271.9 L730.2,283.7 C731.3,285 733.5,285 734.4,283.7 L751.1,267.7 C752.4,266.6 752.4,264.4 751.1,263.5 L739.9,251.7 C738.8,250.4 736.6,250.4 735.7,251.7 L719,267.7 Z'
                    id='nr110'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M260.4,242.6 C261.5,243.9 261.1,245.9 259.7,246.7 L246.9,256.1 C245.6,257.2 243.6,256.8 242.8,255.4 L229.6,236.8 C228.5,235.5 228.9,233.5 230.3,232.7 L243.1,223.3 C244.4,222.2 246.4,222.6 247.2,224 L260.4,242.6 Z'
                    id='nr109'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M687.6,242.6 C686.5,243.9 686.9,245.9 688.3,246.7 L701.1,256.1 C702.4,257.2 704.4,256.8 705.2,255.4 L718.4,236.8 C719.5,235.5 719.1,233.5 717.7,232.7 L704.9,223.3 C703.6,222.2 701.6,222.6 700.8,224 L687.6,242.6 Z'
                    id='nr108'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M230,267.7 C231.3,268.8 231.3,271 230,271.9 L218.8,283.7 C217.7,285 215.5,285 214.6,283.7 L197.9,267.7 C196.6,266.6 196.6,264.4 197.9,263.5 L209.1,251.7 C210.2,250.4 212.4,250.4 213.3,251.7 L230,267.7 Z'
                    id='nr107'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M664.4,227.7 C663.7,229 664,231 665.5,231.9 L679.3,240.4 C680.6,241.1 682.6,240.8 683.5,239.3 L695.7,219.8 C696.4,218.5 696.1,216.5 694.6,215.6 L680.8,207.1 C679.5,206.4 677.5,206.7 676.6,208.2 L664.4,227.7 Z'
                    id='nr106'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M210.9,289.4 C212.2,290.5 212.4,292.4 211.3,293.4 L201.4,305.7 C200.3,307 198.3,307.2 197.2,306.1 L179.1,292.2 C177.8,291.1 177.6,289.2 178.7,288.2 L188.6,275.9 C189.7,274.6 191.7,274.4 192.8,275.5 L210.9,289.4 Z'
                    id='nr105'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M640.3,214.9 C639.7,216.4 640.1,218.2 641.6,218.9 L655.4,226.4 C656.9,227.1 658.6,226.6 659.2,225.1 L669.8,204.5 C670.4,203 670,201.2 668.5,200.5 L654.7,193 C653.2,192.3 651.5,192.8 650.9,194.3 L640.3,214.9 Z'
                    id='nr104'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M192.8,312.3 C194.1,313.4 194.3,315.4 193.5,316.4 L184.2,329.5 C183.1,330.8 181.1,331 180,330.2 L161.2,317.1 C159.9,316 159.7,314 160.5,313 L169.8,299.9 C170.9,298.6 172.9,298.4 174,299.2 L192.8,312.3 Z'
                    id='nr103'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M614.3,202.7 C613.6,204.3 614.3,206 615.8,206.7 L630.5,213.6 C632,214 633.8,213.6 634.5,212 L643.7,190.7 C644.4,189.1 643.7,187.4 642.2,186.7 L627.5,179.8 C626,179.4 624.2,179.8 623.5,181.4 L614.3,202.7 Z'
                    id='nr102'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M175.6,337.4 C176.9,338 177.3,339.9 176.7,341.4 L168.2,354.4 C167.5,355.7 165.6,356.1 164.1,355.5 L144.4,344.2 C143.1,343.6 142.7,341.7 143.3,340.2 L151.8,327.2 C152.5,325.9 154.4,325.5 155.9,326.1 L175.6,337.4 Z'
                    id='nr101'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M589.1,193.5 C588.7,195 589.3,196.7 590.8,197.3 L605.3,202.6 C606.8,203 608.5,202.4 609.1,200.9 L616.8,179.9 C617.2,178.4 616.6,176.7 615.1,176.1 L600.6,170.8 C599.1,170.4 597.4,171 596.8,172.5 L589.1,193.5 Z'
                    id='nr100'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M161.4,363 C162.9,363.7 163.4,365.6 162.7,366.9 L155.4,381.1 C154.7,382.6 152.7,383.1 151.4,382.4 L130.6,372.4 C129.1,371.7 128.6,369.8 129.3,368.5 L136.6,354.3 C137.3,352.8 139.3,352.3 140.6,353 L161.4,363 Z'
                    id='nr99'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M562.1,185.8 C561.7,187.3 562.5,189.1 564.1,189.5 L580,193.6 C581.6,194 583.4,193.2 583.8,191.6 L589.8,169.6 C590.2,168.1 589.4,166.3 587.8,165.9 L571.9,161.8 C570.3,161.4 568.5,162.2 568.1,163.8 L562.1,185.8 Z'
                    id='nr98'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M147.2,390.1 C148.7,390.5 149.5,392.5 148.7,394.1 L143,408.9 C142.6,410.4 140.7,411.3 139.2,410.4 L118.7,401.4 C117.2,401 116.8,399 117.2,397.4 L122.9,382.6 C123.3,381.1 125.2,380.2 126.7,381.1 L147.2,390.1 Z'
                    id='nr97'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M536,180.9 C535.8,182.4 536.7,184.2 538.4,184.4 L554.1,187.7 C555.6,187.9 557.4,187 557.6,185.3 L562,162.6 C562.2,161.1 561.3,159.3 559.6,159.1 L543.9,155.8 C542.4,155.6 540.6,156.5 540.4,158.2 L536,180.9 Z'
                    id='nr96'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M137.1,418.2 C138.6,418.6 139.4,420.1 138.8,421.8 L133.7,436.8 C133.3,438.3 131.8,439.2 130.1,438.5 L108.9,431.2 C107.4,430.8 106.6,428.8 107.2,427.6 L112.3,412.6 C112.7,411.1 114.2,410.2 115.9,410.9 L137.1,418.2 Z'
                    id='nr95'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M510,176.4 C509.8,177.9 511,179.6 512.5,179.8 L527.5,181.7 C529,181.9 530.6,181.1 530.8,179.2 L533.9,157.1 C534.1,155.6 532.9,153.9 531.4,153.7 L516.4,151.8 C514.9,151.6 513.3,152.4 513.1,154.3 L510,176.4 Z'
                    id='nr94'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M129.6,445.6 C131.1,445.8 132.2,447.3 132,449.2 L128.5,464.3 C128.3,465.8 126.7,466.9 124.8,466.6 L102.5,461.7 C101,461.5 99.9,460 100.1,458.1 L103.6,443 C103.8,441.5 105.4,440.4 107.3,440.7 L129.6,445.6 Z'
                    id='nr93'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M482,174.8 C482,176.3 483.1,178.1 485.1,178.1 L501.5,178.8 C503.1,178.8 504.8,177.5 504.8,175.7 L505.9,152.8 C505.9,151.3 504.8,149.5 502.8,149.5 L486.4,148.8 C484.8,148.8 483.1,150.1 483.1,151.9 L482,174.8 Z'
                    id='nr92'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M123.3,475.8 C124.8,476 126.3,477.3 125.9,479.1 L124.4,495.1 C124.2,496.6 122.9,498.1 121.2,497.7 L98.7,495.7 C97.2,495.5 95.7,494.2 96.1,492.4 L97.6,476.4 C97.8,474.9 99.1,473.4 100.8,473.8 L123.3,475.8 Z'
                    id='nr91'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M763,492.3 C761.5,492.3 760,493.8 760,495.6 L761.1,511.7 C761.1,513.2 762.6,514.8 764.4,514.8 L787,513.3 C788.5,513.3 790,511.8 790,510 L788.9,493.9 C788.9,492.4 787.4,490.8 785.6,490.8 L763,492.3 Z'
                    id='nr90'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M466,236.8 C466,238.3 464.9,240.1 462.9,240.1 L446.5,240.8 C444.9,240.8 443.2,239.5 443.2,237.7 L442.1,214.8 C442.1,213.3 443.2,211.5 445.2,211.5 L461.6,210.8 C463.2,210.8 464.9,211.9 464.9,213.9 L466,236.8 Z'
                    id='nr89'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M757.5,462.5 C756,462.7 754.9,464.2 755.1,465.9 L758.4,481.3 C758.6,482.8 760.2,483.9 761.9,483.7 L784.6,479 C786.1,478.8 787.2,477.3 787,475.6 L783.7,460.2 C783.5,458.7 781.9,457.6 780.2,457.8 L757.5,462.5 Z'
                    id='nr88'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M437,238.8 C437.2,240.3 436.3,242 434.6,242.2 L418.8,244.7 C417.3,244.9 415.5,244.1 415.3,242.4 L411.1,220.7 C410.9,219.2 411.8,217.5 413.5,217.3 L429.3,214.8 C430.8,214.6 432.6,215.4 432.8,217.1 L437,238.8 Z'
                    id='nr87'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M749.1,433.6 C747.6,434 746.7,435.6 747.2,437.3 L751.5,452.6 C751.9,454.1 753.4,455 755.2,454.6 L777,447.8 C778.5,447.4 779.4,445.8 778.9,444.1 L774.6,428.8 C774.2,427.3 772.7,426.4 770.9,426.8 L749.1,433.6 Z'
                    id='nr86'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M410.9,243.8 C411.3,245.3 410.5,247.1 408.9,247.5 L393,251.6 C391.4,252 389.6,251.2 389.2,249.6 L383.2,227.6 C382.8,226.1 383.6,224.3 385.2,223.9 L401.1,219.8 C402.7,219.4 404.5,220.2 404.9,221.8 L410.9,243.8 Z'
                    id='nr85'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M738.8,407 C737.3,407.4 736.5,409.4 737.3,411 L743,425.9 C743.4,427.5 745.3,428.3 746.8,427.5 L767.2,418.6 C768.7,418.2 769.5,416.2 768.7,414.6 L763,399.7 C762.6,398.1 760.7,397.3 759.2,398.1 L738.8,407 Z'
                    id='nr84'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M382.9,251.5 C383.3,253 382.7,254.7 381.2,255.3 L366.7,260.6 C365.2,261 363.5,260.4 362.9,258.9 L355.2,237.9 C354.8,236.4 355.4,234.7 356.9,234.1 L371.4,228.8 C372.9,228.4 374.6,229 375.2,230.5 L382.9,251.5 Z'
                    id='nr83'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M725.6,381 C724.1,381.7 723.6,383.6 724.3,384.9 L731.6,399.1 C732.3,400.6 734.3,401.1 735.6,400.4 L756.4,390.4 C757.9,389.7 758.4,387.8 757.7,386.5 L750.4,372.3 C749.7,370.8 747.7,370.3 746.4,371 L725.6,381 Z'
                    id='nr82'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M356.7,261.7 C357.4,263.2 356.7,265 355.2,265.7 L340.6,272.5 C339.1,273.2 337.3,272.5 336.7,271 L327.3,249.8 C326.6,248.3 327.3,246.5 328.8,245.8 L343.4,239 C344.9,238.3 346.7,239 347.3,240.5 L356.7,261.7 Z'
                    id='nr81'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M711.4,355.4 C710.1,356 709.7,357.9 710.3,359.4 L718.8,372.4 C719.5,373.7 721.4,374.1 722.9,373.5 L742.6,362.2 C743.9,361.6 744.3,359.7 743.7,358.2 L735.2,345.2 C734.5,343.9 732.6,343.5 731.1,344.1 L711.4,355.4 Z'
                    id='nr80'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M330.7,274.1 C331.3,275.4 330.9,277.4 329.6,278.3 L316.4,286.4 C315.1,287.1 313.2,286.6 312.4,285.3 L301.3,265.3 C300.7,264 301.1,262 302.4,261.1 L315.6,253 C316.9,252.3 318.8,252.8 319.6,254.1 L330.7,274.1 Z'
                    id='nr79'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M695.1,333.8 C693.8,334.9 693.6,336.8 694.7,337.9 L704.2,350.6 C705.3,351.9 707.3,352.1 708.4,351 L726.9,337.6 C728.2,336.5 728.4,334.6 727.3,333.5 L717.8,320.8 C716.7,319.5 714.7,319.3 713.6,320.4 L695.1,333.8 Z'
                    id='nr78'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M306.4,287.8 C307.5,289.1 306.8,291.1 305.7,292 L292.7,301.2 C291.4,302.3 289.4,301.6 288.6,300.5 L275.6,281.7 C274.5,280.4 275.2,278.4 276.3,277.5 L289.3,268.3 C290.6,267.2 292.6,267.9 293.4,269 L306.4,287.8 Z'
                    id='nr77'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M676,311.7 C674.7,312.8 674.7,315 676,315.9 L687.2,327.7 C688.3,329 690.5,329 691.4,327.7 L708.1,311.7 C709.4,310.6 709.4,308.4 708.1,307.5 L696.9,295.7 C695.8,294.4 693.6,294.4 692.7,295.7 L676,311.7 Z'
                    id='nr76'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M273,311.7 C274.3,312.8 274.3,315 273,315.9 L261.8,327.7 C260.7,329 258.5,329 257.6,327.7 L240.9,311.7 C239.6,310.6 239.6,308.4 240.9,307.5 L252.1,295.7 C253.2,294.4 255.4,294.4 256.3,295.7 L273,311.7 Z'
                    id='nr75'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M642.6,287.8 C641.5,289.1 642.2,291.1 643.3,292 L656.3,301.2 C657.6,302.3 659.6,301.6 660.4,300.5 L673.4,281.7 C674.5,280.4 673.8,278.4 672.7,277.5 L659.7,268.3 C658.4,267.2 656.4,267.9 655.6,269 L642.6,287.8 Z'
                    id='nr74'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M253.9,333.8 C255.2,334.9 255.4,336.8 254.3,337.9 L244.8,350.6 C243.7,351.9 241.7,352.1 240.6,351 L222.1,337.6 C220.8,336.5 220.6,334.6 221.7,333.5 L231.2,320.8 C232.3,319.5 234.3,319.3 235.4,320.4 L253.9,333.8 Z'
                    id='nr73'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M618.3,274.1 C617.7,275.4 618.1,277.4 619.4,278.3 L632.6,286.4 C633.9,287.1 635.8,286.6 636.6,285.3 L647.7,265.3 C648.3,264 647.9,262 646.6,261.1 L633.4,253 C632.1,252.3 630.2,252.8 629.4,254.1 L618.3,274.1 Z'
                    id='nr72'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M237.6,355.4 C238.9,356 239.3,357.9 238.7,359.4 L230.2,372.4 C229.5,373.7 227.6,374.1 226.1,373.5 L206.4,362.2 C205.1,361.6 204.7,359.7 205.3,358.2 L213.8,345.2 C214.5,343.9 216.4,343.5 217.9,344.1 L237.6,355.4 Z'
                    id='nr71'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M592.3,261.7 C591.6,263.2 592.3,265 593.8,265.7 L608.4,272.5 C609.9,273.2 611.7,272.5 612.3,271 L621.7,249.8 C622.4,248.3 621.7,246.5 620.2,245.8 L605.6,239 C604.1,238.3 602.3,239 601.7,240.5 L592.3,261.7 Z'
                    id='nr70'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M223.4,381 C224.9,381.7 225.4,383.6 224.7,384.9 L217.4,399.1 C216.7,400.6 214.7,401.1 213.4,400.4 L192.6,390.4 C191.1,389.7 190.6,387.8 191.3,386.5 L198.6,372.3 C199.3,370.8 201.3,370.3 202.6,371 L223.4,381 Z'
                    id='nr69'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M566.1,251.5 C565.7,253 566.3,254.7 567.8,255.3 L582.3,260.6 C583.8,261 585.5,260.4 586.1,258.9 L593.8,237.9 C594.2,236.4 593.6,234.7 592.1,234.1 L577.6,228.8 C576.1,228.4 574.4,229 573.8,230.5 L566.1,251.5 Z'
                    id='nr68'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M210.2,407 C211.7,407.4 212.5,409.4 211.7,411 L206,425.9 C205.6,427.5 203.7,428.3 202.2,427.5 L181.8,418.6 C180.3,418.2 179.5,416.2 180.3,414.6 L186,399.7 C186.4,398.1 188.3,397.3 189.8,398.1 L210.2,407 Z'
                    id='nr67'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M538.1,243.8 C537.7,245.3 538.5,247.1 540.1,247.5 L556,251.6 C557.6,252 559.4,251.2 559.8,249.6 L565.8,227.6 C566.2,226.1 565.4,224.3 563.8,223.9 L547.9,219.8 C546.3,219.4 544.5,220.2 544.1,221.8 L538.1,243.8 Z'
                    id='nr66'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M199.9,433.6 C201.4,434 202.3,435.6 201.8,437.3 L197.5,452.6 C197.1,454.1 195.6,455 193.8,454.6 L172,447.8 C170.5,447.4 169.6,445.8 170.1,444.1 L174.4,428.8 C174.8,427.3 176.3,426.4 178.1,426.8 L199.9,433.6 Z'
                    id='nr65'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M511,238.8 C510.8,240.3 511.7,242 513.4,242.2 L529.4,244.7 C531,244.9 532.7,244.1 532.9,242.4 L536.9,220.7 C537.1,219.2 536.2,217.5 534.5,217.3 L518.5,214.8 C516.9,214.6 515.2,215.4 515,217.1 L511,238.8 Z'
                    id='nr64'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M191.5,462.5 C193,462.7 194.1,464.2 193.9,465.9 L190.6,481.3 C190.4,482.8 188.8,483.9 187.1,483.7 L164.4,479 C162.9,478.8 161.8,477.3 162,475.6 L165.3,460.2 C165.5,458.7 167.1,457.6 168.8,457.8 L191.5,462.5 Z'
                    id='nr63'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M483,236.8 C483,238.3 484.1,240.1 486.1,240.1 L502.5,240.8 C504.1,240.8 505.8,239.5 505.8,237.7 L506.9,214.8 C506.9,213.3 505.8,211.5 503.8,211.5 L487.4,210.8 C485.8,210.8 484.1,211.9 484.1,213.9 L483,236.8 Z'
                    id='nr62'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M185.9,491.5 C187.4,491.5 189,493 189,494.7 L187.9,510.7 C187.9,512.2 186.4,513.7 184.6,513.7 L162,512 C160.5,512 158.9,510.5 158.9,508.8 L160,492.8 C160,491.3 161.5,489.8 163.3,489.8 L185.9,491.5 Z'
                    id='nr61'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M700.6,491.7 C699.1,491.9 697.6,493.2 698.1,495 L700,510.1 C700.2,511.6 701.5,513 703.4,512.6 L725.4,509.7 C726.9,509.5 728.4,508 727.9,506.4 L726,491.3 C725.8,489.8 724.5,488.4 722.6,488.8 L700.6,491.7 Z'
                    id='nr60'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M465,295.7 C465.2,297.2 463.9,298.9 462.5,299.1 L446.8,300.6 C445.3,300.8 443.6,299.5 443.4,298 L441.1,275.6 C440.9,274.1 442.2,272.4 443.6,272.2 L459.3,270.7 C460.8,270.5 462.5,271.8 462.5,273.3 L465,295.7 Z'
                    id='nr59'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M693.2,463 C691.7,463.2 690.6,464.9 691.2,466.6 L694.9,481.6 C695.1,483.1 696.9,484.1 698.6,483.5 L720.8,478.4 C722.3,478.2 723.4,476.5 722.8,474.8 L719.1,459.8 C718.9,458.3 717.1,457.3 715.4,457.9 L693.2,463 Z'
                    id='nr58'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M434,299.5 C434.2,301 433.4,302.8 431.7,303.2 L416.5,306.7 C415,306.9 413.3,306 412.9,304.3 L408,282 C407.8,280.5 408.6,278.7 410.3,278.3 L425.5,274.8 C427,274.6 428.7,275.5 429.1,277.2 L434,299.5 Z'
                    id='nr57'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M683.9,434.6 C682.4,435 681.6,436.9 682.2,438.4 L687.5,452.8 C687.9,454.3 689.8,455.1 691.3,454.5 L712.1,446.9 C713.6,446.5 714.4,444.6 713.8,443.1 L708.5,428.7 C708.1,427.2 706.2,426.4 704.7,427 L683.9,434.6 Z'
                    id='nr56'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M403.9,306.9 C404.3,308.4 403.7,310.1 402.2,310.5 L387.3,315.6 C385.8,316 384.1,315.4 383.7,313.9 L376.2,292.8 C375.8,291.3 376.4,289.6 377.9,289 L392.8,283.9 C394.3,283.5 396,284.1 396.4,285.6 L403.9,306.9 Z'
                    id='nr55'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M670.6,407.3 C669.1,407.9 668.6,409.9 669.3,411.2 L676.8,425.2 C677.5,426.7 679.4,427.1 680.8,426.5 L701.5,416.2 C703,415.6 703.5,413.6 702.8,412.3 L695.3,398.3 C694.6,396.8 692.7,396.4 691.3,397 L670.6,407.3 Z'
                    id='nr54'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M375.7,318.2 C376.4,319.8 375.7,321.5 374.4,322.2 L360.1,329.5 C358.6,330.2 356.8,329.5 356.2,328.2 L346.2,307.4 C345.5,305.8 346.2,304.1 347.5,303.4 L361.8,296.1 C363.3,295.4 365.1,295.9 365.7,297.4 L375.7,318.2 Z'
                    id='nr53'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M653.3,381.2 C652,382.3 651.5,384.3 652.6,385.3 L661.6,398.4 C662.3,399.7 664.7,400.1 665.8,399.1 L684.7,386.2 C686,385.1 686.5,383.1 685.4,382.1 L676.4,369 C675.3,367.7 673.3,367.3 672.2,368.3 L653.3,381.2 Z'
                    id='nr52'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M349.6,331 C350.3,332.3 350,334.2 348.9,335 L335.4,343.4 C334.1,344 332.1,343.8 331.2,342.8 L318.3,324.5 C317.6,323.2 317.9,321.3 319,320.5 L332.5,312.1 C333.8,311.5 335.8,311.7 336.7,312.7 L349.6,331 Z'
                    id='nr51'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M634,357 C632.7,358.1 632.7,360 633.8,361 L644.4,372.7 C645.5,374 647.5,374 648.6,372.9 L666,358.4 C667.3,357.3 667.3,355.4 666.2,354.4 L655.6,342.7 C654.5,341.4 652.5,341.4 651.4,342.5 L634,357 Z'
                    id='nr50'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M315,357 C316.3,358.1 316.3,360 315.2,361 L304.6,372.7 C303.5,374 301.5,374 300.4,372.9 L283,358.5 C281.7,357.4 281.7,355.5 282.8,354.5 L293.4,342.8 C294.5,341.5 296.5,341.5 297.6,342.6 L315,357 Z'
                    id='nr49'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M599.4,331 C598.7,332.3 599,334.2 600.1,335 L613.6,343.4 C614.9,344 616.9,343.8 617.8,342.8 L630.7,324.5 C631.4,323.2 631.1,321.3 630,320.5 L616.5,312.1 C615.2,311.5 613.2,311.7 612.3,312.7 L599.4,331 Z'
                    id='nr48'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M294.7,381.2 C296,382.3 296.5,384.3 295.4,385.3 L286.4,398.4 C285.3,399.7 283.3,400.1 282.2,399.1 L263.3,386.2 C262,385.1 261.5,383.1 262.6,382.1 L271.6,369 C272.7,367.7 274.7,367.3 275.8,368.3 L294.7,381.2 Z'
                    id='nr47'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M572.3,318.2 C571.6,319.8 572.3,321.5 573.6,322.2 L587.9,329.5 C589.4,330.2 591.2,329.5 591.8,328.2 L601.8,307.4 C602.5,305.8 601.8,304.1 600.5,303.4 L586.2,296.1 C584.7,295.4 582.9,295.9 582.3,297.4 L572.3,318.2 Z'
                    id='nr46'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M278.4,407.3 C279.9,407.9 280.4,409.9 279.7,411.2 L272.2,425.2 C271.5,426.7 269.6,427.1 268.2,426.5 L247.5,416.2 C246,415.6 245.5,413.6 246.2,412.3 L253.7,398.3 C254.4,396.8 256.3,396.4 257.7,397 L278.4,407.3 Z'
                    id='nr45'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M545.1,306.9 C544.7,308.4 545.3,310.1 546.8,310.5 L561.5,315.6 C563,316 564.8,315.4 565.2,313.9 L572.8,292.8 C573.2,291.3 572.6,289.6 571.1,289 L555.9,283.9 C554.4,283.5 552.6,284.1 552.2,285.6 L545.1,306.9 Z'
                    id='nr44'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M264.1,434.6 C265.6,435 266.4,436.9 265.8,438.4 L260.5,452.8 C260.1,454.3 258.2,455.1 256.7,454.5 L235.9,446.9 C234.4,446.5 233.6,444.6 234.2,443.1 L239.5,428.7 C239.9,427.2 241.8,426.4 243.3,427 L264.1,434.6 Z'
                    id='nr43'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M515,299.5 C514.8,301 515.6,302.8 517.3,303.2 L532.5,306.7 C534,306.9 535.7,306 536.1,304.3 L541,282 C541.2,280.5 540.4,278.7 538.7,278.3 L523.5,274.8 C522,274.6 520.3,275.5 519.9,277.2 L515,299.5 Z'
                    id='nr42'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M254.8,463 C256.3,463.2 257.4,464.9 256.8,466.6 L253.1,481.6 C252.9,483.1 251.1,484.1 249.4,483.5 L227.2,478.4 C225.7,478.2 224.6,476.5 225.2,474.8 L228.9,459.8 C229.1,458.3 230.9,457.3 232.6,457.9 L254.8,463 Z'
                    id='nr41'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M483,295.7 C482.8,297.2 484.1,298.9 485.5,299.1 L501.2,300.6 C502.7,300.8 504.4,299.5 504.6,298 L506.9,275.6 C507.1,274.1 505.8,272.4 504.4,272.2 L488.7,270.7 C487.2,270.5 485.5,271.8 485.3,273.3 L483,295.7 Z'
                    id='nr40'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M248.4,491.7 C249.9,491.9 251.4,493.2 250.9,495 L249,510.1 C248.8,511.6 247.5,513 245.6,512.6 L223.6,509.7 C222.1,509.5 220.6,508 221.1,506.4 L223,491.3 C223.2,489.8 224.5,488.4 226.4,488.8 L248.4,491.7 Z'
                    id='nr39'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M635.6,494.7 C634.1,494.9 632.6,496.2 633.1,498 L635,513.1 C635.2,514.6 636.5,516 638.4,515.6 L660.4,512.7 C661.9,512.5 663.4,511.2 662.9,509.4 L661,494.3 C660.8,492.8 659.3,491.4 657.6,491.8 L635.6,494.7 Z'
                    id='nr38'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M466,357.6 C466.2,359.1 464.9,360.8 463.5,361 L448.4,362.7 C446.9,362.9 445.2,361.6 445,360.1 L442.1,337.8 C441.9,336.3 443.2,334.6 444.6,334.4 L459.7,332.7 C461.2,332.5 462.9,333.8 463.1,335.3 L466,357.6 Z'
                    id='nr37'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M629.1,469 C627.6,469.4 626.7,471 627.2,472.8 L631.5,488.5 C631.9,490.1 633.4,491.2 635.2,490.5 L657,484.3 C658.5,483.9 659.4,482.3 658.9,480.5 L654.6,464.8 C654.2,463.2 652.7,462.4 650.9,462.8 L629.1,469 Z'
                    id='nr36'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M440.9,361.8 C441.3,363.3 440.5,365.1 438.9,365.5 L423,369.6 C421.4,370 419.6,369.2 419.2,367.6 L413.2,345.6 C412.8,344.1 413.6,342.3 415.2,341.9 L431.1,337.8 C432.7,337.4 434.5,338.2 434.9,339.8 L440.9,361.8 Z'
                    id='nr35'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M618.7,445.3 C617.1,446 616.7,447.7 617.1,449.3 L624,464 C624.7,465.5 626.4,466 628,465.5 L649.3,456 C650.9,455.3 651.3,453.6 650.9,452 L644,437.3 C643.3,435.8 641.6,435.3 640,435.8 L618.7,445.3 Z'
                    id='nr34'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M414.8,369 C415.2,370.5 414.8,372.2 413.3,372.8 L399.2,378.5 C397.7,378.9 396.1,378.5 395.4,377 L387,356.4 C386.6,354.9 387,353.2 388.5,352.6 L402.6,346.9 C404.1,346.5 405.7,346.9 406.4,348.4 L414.8,369 Z'
                    id='nr33'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M606.4,423.4 C605.1,424 603.7,425.9 604.3,427.4 L612.8,440.4 C613.5,441.7 615.4,442.1 616.9,441.5 L636.6,430.2 C637.9,429.6 638.3,427.7 637.7,426.2 L629.2,413.2 C628.5,411.9 626.6,411.5 625.1,412.1 L606.4,423.4 Z'
                    id='nr32'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M389.7,379.1 C390.3,380.4 389.9,382.4 388.6,383.3 L375.4,391.4 C374.1,392.1 372.2,391.6 371.4,390.3 L360.3,370.3 C359.7,369 360.1,367 361.4,366.1 L374.6,358 C375.9,357.3 377.8,357.8 378.6,359.1 L389.7,379.1 Z'
                    id='nr31'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M589.2,402.6 C587.9,403.7 587.6,405.6 588.8,406.6 L599,418.6 C600.1,419.9 602.1,420.1 603.2,419 L620.9,404.8 C622.2,403.7 622.5,401.8 621.3,400.8 L611.1,388.8 C610,387.5 608,387.3 606.9,388.4 L589.2,402.6 Z'
                    id='nr30'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M359.8,402.6 C361.1,403.7 361.4,405.6 360.2,406.6 L350,418.6 C348.9,419.9 346.9,420.1 345.8,419 L328.1,404.8 C326.8,403.7 326.5,401.8 327.7,400.8 L337.9,388.8 C339,387.5 341,387.3 342.1,388.4 L359.8,402.6 Z'
                    id='nr29'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M561.3,379.1 C560.7,380.4 561.1,382.4 562.4,383.3 L575.6,391.4 C576.9,392.1 578.8,391.6 579.6,390.3 L590.7,370.3 C591.3,369 590.9,367 589.6,366.1 L576.4,358 C575.1,357.3 573.2,357.8 572.4,359.1 L561.3,379.1 Z'
                    id='nr28'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M342.6,423.4 C343.9,424 344.3,425.9 343.7,427.4 L335.2,440.4 C334.5,441.7 332.6,442.1 331.1,441.5 L311.4,430.2 C310.1,429.6 309.7,427.7 310.3,426.2 L318.8,413.2 C319.5,411.9 321.4,411.5 322.9,412.1 L342.6,423.4 Z'
                    id='nr27'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M536.2,369 C535.8,370.5 536.2,372.2 537.7,372.8 L551.8,378.5 C553.3,378.9 554.9,378.5 555.6,377 L564,356.4 C564.4,354.9 564,353.2 562.5,352.6 L548.4,346.9 C546.9,346.5 545.3,346.9 544.6,348.4 L536.2,369 Z'
                    id='nr26'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M330.3,445.3 C331.9,446 332.3,447.7 331.9,449.3 L325,464 C324.3,465.5 322.6,466 321,465.5 L299.7,456 C298.1,455.3 297.7,453.6 298.1,452 L305,437.3 C305.7,435.8 307.4,435.3 309,435.8 L330.3,445.3 Z'
                    id='nr25'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M510.1,361.8 C509.7,363.3 510.5,365.1 512.1,365.5 L528,369.6 C529.6,370 531.4,369.2 531.8,367.6 L537.8,345.6 C538.2,344.1 537.4,342.3 535.8,341.9 L519.9,337.8 C518.3,337.4 516.5,338.2 516.1,339.8 L510.1,361.8 Z'
                    id='nr24'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M319.9,469 C321.4,469.4 322.3,471 321.8,472.8 L317.5,488.5 C317.1,490.1 315.6,491.2 313.8,490.5 L292,484.3 C290.5,483.9 289.6,482.3 290.1,480.5 L294.4,464.8 C294.8,463.2 296.3,462.4 298.1,462.8 L319.9,469 Z'
                    id='nr23'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M485,357.6 C484.8,359.1 486.1,360.8 487.5,361 L502.6,362.7 C504.1,362.9 505.8,361.6 506,360.1 L508.9,337.8 C509.1,336.3 507.8,334.6 506.4,334.4 L491.3,332.7 C489.8,332.5 488.1,333.8 487.9,335.3 L485,357.6 Z'
                    id='nr22'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M313.4,494.7 C314.9,494.9 316.4,496.2 315.9,498 L314,513.1 C313.8,514.6 312.5,516 310.6,515.6 L288.6,512.7 C287.1,512.5 285.6,511.2 286.1,509.4 L288,494.3 C288.2,492.8 289.5,491.4 291.4,491.8 L313.4,494.7 Z'
                    id='nr21'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M562.1,471.1 C560.6,471.5 559.7,473.1 560.2,474.9 L564.5,490.7 C564.9,492.3 566.4,493.1 568.2,492.7 L590,486.5 C591.5,486.1 592.4,484.5 591.9,482.7 L587.6,466.9 C587.2,465.3 585.7,464.5 583.9,464.9 L562.1,471.1 Z'
                    id='nr20'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M464,420.6 C464.2,422.1 462.9,423.8 461.5,424 L446.4,425.7 C444.9,425.9 443.2,424.6 443,423.1 L440.1,400.8 C439.9,399.3 441.2,397.6 442.6,397.4 L457.7,395.7 C459.2,395.5 460.9,396.8 461.1,398.3 L464,420.6 Z'
                    id='nr19'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M545.2,448.6 C543.9,449.7 543.6,451.6 544.8,452.6 L555,464.6 C556.1,465.9 558.1,466.1 559.2,465 L576.9,450.8 C578.2,449.7 578.5,447.8 577.3,446.8 L567.3,434.8 C566.2,433.5 564.2,433.3 563.1,434.4 L545.2,448.6 Z'
                    id='nr18'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M435.7,426.1 C436.3,427.4 435.9,429.4 434.6,430.3 L421.4,438.4 C420.1,439.1 418.2,438.6 417.4,437.3 L406.3,417.3 C405.7,416 406.1,414 407.4,413.1 L420.6,405 C421.9,404.3 423.8,404.8 424.6,406.1 L435.7,426.1 Z'
                    id='nr17'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M512.3,426.1 C511.7,427.4 512.1,429.4 513.4,430.3 L526.6,438.4 C527.9,439.1 529.8,438.6 530.6,437.3 L541.7,417.3 C542.3,416 541.9,414 540.6,413.1 L527.4,405 C526.1,404.3 524.2,404.8 523.4,406.1 L512.3,426.1 Z'
                    id='nr16'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M402.8,448.6 C404.1,449.7 404.4,451.6 403.2,452.6 L393,464.6 C391.9,465.9 389.9,466.1 388.8,465 L371.1,450.8 C369.8,449.7 369.5,447.8 370.7,446.8 L380.9,434.8 C382,433.5 384,433.3 385.1,434.4 L402.8,448.6 Z'
                    id='nr15'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M485,420.6 C484.8,422.1 486.1,423.8 487.5,424 L502.6,425.7 C504.1,425.9 505.8,424.6 506,423.1 L508.9,400.8 C509.1,399.3 507.8,397.6 506.4,397.4 L491.3,395.7 C489.8,395.5 488.1,396.8 487.9,398.3 L485,420.6 Z'
                    id='nr14'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M386.9,471.1 C388.4,471.5 389.3,473.1 388.8,474.9 L384.5,490.7 C384.1,492.3 382.6,493.1 380.8,492.7 L359,486.5 C357.5,486.1 356.6,484.5 357.1,482.7 L361.4,466.9 C361.8,465.3 363.3,464.5 365.1,464.9 L386.9,471.1 Z'
                    id='nr13'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M560.9,571.1 L545.5,571.1 C543.7,571.1 542.3,569.7 542.3,567.9 L542.3,545 C542.3,543.2 543.7,541.8 545.5,541.8 L560.9,541.8 C562.7,541.8 564.1,543.2 564.1,545 L564.1,567.9 C564.1,569.7 562.6,571.1 560.9,571.1 Z'
                    id='nr12'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M469.7,571.1 L454.3,571.1 C452.5,571.1 451.1,569.7 451.1,567.9 L451.1,545 C451.1,543.2 452.5,541.8 454.3,541.8 L469.7,541.8 C471.5,541.8 472.9,543.2 472.9,545 L472.9,567.9 C473,569.7 471.5,571.1 469.7,571.1 Z'
                    id='nr11'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M530.5,571.1 L515.1,571.1 C513.3,571.1 511.9,569.7 511.9,567.9 L511.9,545 C511.9,543.2 513.3,541.8 515.1,541.8 L530.5,541.8 C532.3,541.8 533.7,543.2 533.7,545 L533.7,567.9 C533.7,569.7 532.3,571.1 530.5,571.1 Z'
                    id='nr10'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M439.4,571.1 L424,571.1 C422.2,571.1 420.8,569.7 420.8,567.9 L420.8,545 C420.8,543.2 422.2,541.8 424,541.8 L439.4,541.8 C441.2,541.8 442.6,543.2 442.6,545 L442.6,567.9 C442.6,569.7 441.1,571.1 439.4,571.1 Z'
                    id='nr9'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M500.1,571.1 L484.7,571.1 C482.9,571.1 481.5,569.7 481.5,567.9 L481.5,545 C481.5,543.2 482.9,541.8 484.7,541.8 L500.1,541.8 C501.9,541.8 503.3,543.2 503.3,545 L503.3,567.9 C503.3,569.7 501.9,571.1 500.1,571.1 Z'
                    id='nr8'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M409,571.1 L393.6,571.1 C391.8,571.1 390.4,569.7 390.4,567.9 L390.4,545 C390.4,543.2 391.8,541.8 393.6,541.8 L409,541.8 C410.8,541.8 412.2,543.2 412.2,545 L412.2,567.9 C412.2,569.7 410.8,571.1 409,571.1 Z'
                    id='nr7'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M656.4,641.3 C656.1,639.8 654.2,638.5 652.9,639 L637.1,642.2 C635.6,642.5 634.3,644.3 634.8,645.7 L639.3,668.3 C639.6,669.8 641.5,671.1 642.8,670.6 L658.6,667.4 C660.1,667.1 661.4,665.3 660.9,663.9 L656.4,641.3 Z'
                    id='nr6'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M560.9,624.9 L545.5,624.9 C543.7,624.9 542.3,623.5 542.3,621.7 L542.3,598.8 C542.3,597 543.7,595.6 545.5,595.6 L560.9,595.6 C562.7,595.6 564.1,597 564.1,598.8 L564.1,621.7 C564.1,623.5 562.6,624.9 560.9,624.9 Z'
                    id='nr5'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M619.5,647.4 C619.3,645.7 617.6,644.3 616.4,644.6 L600.5,645.7 C598.8,645.8 597.5,647.5 597.8,648.7 L600.2,671.4 C600.4,673.1 602.1,674.5 603.3,674.2 L619.2,673.1 C620.9,673 622.2,671.3 621.9,670.1 L619.5,647.4 Z'
                    id='nr4'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M530.5,624.9 L515.1,624.9 C513.3,624.9 511.9,623.5 511.9,621.7 L511.9,598.8 C511.9,597 513.3,595.6 515.1,595.6 L530.5,595.6 C532.3,595.6 533.7,597 533.7,598.8 L533.7,621.7 C533.7,623.5 532.3,624.9 530.5,624.9 Z'
                    id='nr3'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M560.9,676.1 L545.5,676.1 C543.7,676.1 542.3,674.7 542.3,672.9 L542.3,650 C542.3,648.2 543.7,646.8 545.5,646.8 L560.9,646.8 C562.7,646.8 564.1,648.2 564.1,650 L564.1,672.9 C564.1,674.7 562.6,676.1 560.9,676.1 Z'
                    id='nr2'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M484.9,676.1 L469.5,676.1 C467.7,676.1 466.3,674.7 466.3,672.9 L466.3,650 C466.3,648.2 467.7,646.8 469.5,646.8 L484.9,646.8 C486.7,646.8 488.1,648.2 488.1,650 L488.1,672.9 C488.2,674.7 486.7,676.1 484.9,676.1 Z'
                    id='nr1'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  {isMobile && council === 'nr' && (
                    <circle
                      id='nrcircle'
                      cx={this.state.touchPos.x}
                      cy={this.state.touchPos.y}
                      r={this.state.circleRadius}
                      stroke='#282828'
                      strokeWidth={5}
                      fill='red'
                    />
                  )}
                </g>
              </svg>
            </div>
            <ListComponent
              council={council}
              data={council === 'nr' ? this.props.nr : this.props.sr}
              update={isMobile ? latestTouch : null}
              hasFilter={!this.state.filterIsActive}
            />
          </div>
        )}
        {council === 'sr' && (
          <div>
            <FilterComponent
              setFilterState={bool => this.setState({ filterIsActive: bool })}
              council={council}
              data={this.props.sr}
              update={isMobile ? latestTouch : null}
              updateHandler={this.applyTextFilter}
              dropdownHandler={this.applyDropdownFilter}
            />
            <div
              className={`ui center aligned text container tooltip-container ${
                !this.state.showTooltip ? '' : 'white'
              }`}
            >
              {!this.state.showTooltip ? (
                <div className='call-to-action'>
                  <div className='slide-in-bck-center'>
                    {isMobile ? (
                      <span className=''>
                        {this.state.locale.SVGComponent.CallToAction.Mobile}
                      </span>
                    ) : (
                      <span className=''>
                        {this.state.locale.SVGComponent.CallToAction.Desktop}
                      </span>
                    )}
                  </div>
                </div>
              ) : (
                <div className='politician-preview'>
                  <div
                    className='slide-in-bck-center'
                    onClick={e =>
                      this.showOverlay(e, currentPolitician.Elected === 'Ja')
                    }
                  >
                    {currentPolitician.Elected === 'Ja' ? (
                      <div className='flex-parent'>
                        <Img
                          src={`https://interaktiv.tagesanzeiger.ch/imageUpload/interaktives-parlament/${this.escapeName(
                            currentPolitician.Nachname
                          )}_${this.escapeName(currentPolitician.Vorname)}.png`}
                          className='ui avatar image'
                          style={{
                            backgroundColor:
                              PARTY_COLORS[currentPolitician.Partei]
                          }}
                          loader={ImagePlaceholder}
                          unloader={ImagePlaceholder}
                        />
                        <div className='slide-in-bck-center'>
                          <span style={{ fontWeight: 800 }}>
                            {currentPolitician.Vorname}{' '}
                            {currentPolitician.Nachname}
                          </span>
                          <br />
                          {
                            this.state.globalLocale.UI.Global.Parties[
                              currentPolitician.Partei
                            ]
                          }{' '}
                          {
                            this.state.globalLocale.UI.Global.Cantons[
                              currentPolitician.Kanton
                            ]
                          }
                        </div>
                        {isMobile && (
                          <a
                            style={{
                              paddingLeft: '1rem',
                              fontSize: '0.8rem',
                              alignSelf: 'flex-end'
                            }}
                            className='shake-left'
                          >
                            {
                              this.state.locale.SVGComponent.CallToAction
                                .Portrait[1]
                            }
                            <i className='ui icon chevron right' />
                          </a>
                        )}
                        {textFilterIsActive && !isMobile && (
                          <a
                            style={{
                              paddingLeft: '1rem',
                              fontSize: '0.8rem',
                              alignSelf: 'flex-end'
                            }}
                            className='shake-left'
                          >
                            {
                              this.state.locale.SVGComponent.CallToAction
                                .Portrait[0]
                            }
                            <i className='ui icon chevron right' />
                          </a>
                        )}
                      </div>
                    ) : (
                      <div className='flex-parent'>
                        <div className='slide-in-bck-center'>
                          <span style={{ fontWeight: 400, lineHeight: 2 }}>
                            {currentPolitician['Funktion ' + this.context]}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div
              id={`dropbox-${council}`}
              className={`dropbox ${isMobile ? 'grey' : ''} ${
                this.state.touchMoves > 0 ? 'active' : ''
              }`}
            >
              <svg
                id='sr'
                width='950px'
                height='322px'
                viewBox='0 0 950 322'
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                xmlnsXlink='http://www.w3.org/1999/xlink'
                style={{
                  width: '100%',
                  height: 'auto',
                  pointerEvents: textFilterIsActive ? 'none' : 'auto'
                }}
              >
                <filter id='dropshadow' x='-2' y='-2' width='200' height='200'>
                  <feGaussianBlur stdDeviation='1' />
                </filter>
                <g
                  id='parliament-sr'
                  stroke='none'
                  strokeWidth='1'
                  fill='none'
                  fillRule='evenodd'
                >
                  <path
                    d='M561.14088,272.414014 C560.84088,270.914014 558.94088,269.614014 557.64088,270.114014 L541.84088,273.314014 C540.34088,273.614014 539.04088,275.414014 539.54088,276.814014 L544.04088,299.414014 C544.34088,300.914014 546.24088,302.214014 547.54088,301.714014 L563.34088,298.514014 C564.84088,298.214014 566.14088,296.414014 565.64088,295.014014 L561.14088,272.414014 Z'
                    id='sr55'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M402.94088,278.414014 C403.14088,276.714014 404.84088,275.314014 406.04088,275.614014 L421.94088,276.714014 C423.64088,276.814014 424.94088,278.514014 424.64088,279.714014 L422.24088,302.414014 C422.04088,304.114014 420.34088,305.514014 419.14088,305.214014 L403.24088,304.114014 C401.54088,304.014014 400.24088,302.314014 400.54088,301.114014 L402.94088,278.414014 Z'
                    id='sr52'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M368.54088,272.414014 C368.84088,270.914014 370.74088,269.614014 372.04088,270.114014 L387.84088,273.314014 C389.34088,273.614014 390.64088,275.414014 390.14088,276.814014 L385.64088,299.414014 C385.34088,300.914014 383.44088,302.214014 382.14088,301.714014 L366.34088,298.514014 C364.84088,298.214014 363.54088,296.414014 364.04088,295.014014 L368.54088,272.414014 Z'
                    id='sr54'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M582.74088,225.614014 C582.44088,224.114014 580.34088,223.214014 578.94088,223.614014 L563.94088,228.614014 C562.44088,228.914014 561.54088,231.014014 562.04088,232.314014 L569.74088,254.014014 C570.04088,255.514014 572.14088,256.414014 573.54088,256.014014 L588.54088,251.014014 C590.04088,250.714014 590.94088,248.614014 590.44088,247.314014 L582.74088,225.614014 Z'
                    id='sr53'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M553.44088,235.214014 C553.14088,233.714014 551.24088,232.414014 549.94088,232.914014 L534.14088,236.114014 C532.64088,236.414014 531.34088,238.214014 531.84088,239.614014 L536.34088,262.214014 C536.64088,263.714014 538.54088,265.014014 539.84088,264.514014 L555.64088,261.314014 C557.14088,261.014014 558.44088,259.214014 557.94088,257.814014 L553.44088,235.214014 Z'
                    id='sr51'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M522.54088,241.214014 C522.34088,239.514014 520.64088,238.114014 519.44088,238.414014 L503.54088,239.514014 C501.84088,239.614014 500.54088,241.314014 500.84088,242.514014 L503.24088,265.214014 C503.44088,266.914014 505.14088,268.314014 506.34088,268.014014 L522.24088,266.914014 C523.94088,266.814014 525.24088,265.114014 524.94088,263.914014 L522.54088,241.214014 Z'
                    id='sr49'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M408.04088,240.414014 C408.24088,238.714014 409.94088,237.314014 411.14088,237.614014 L427.04088,238.714014 C428.74088,238.814014 430.04088,240.514014 429.74088,241.714014 L427.34088,264.414014 C427.14088,266.114014 425.44088,267.514014 424.24088,267.214014 L408.34088,266.114014 C406.64088,266.014014 405.34088,264.314014 405.64088,263.114014 L408.04088,240.414014 Z'
                    id='sr46'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M377.54088,234.414014 C377.84088,232.914014 379.74088,231.614014 381.04088,232.114014 L396.84088,235.314014 C398.34088,235.614014 399.64088,237.414014 399.14088,238.814014 L394.64088,261.414014 C394.34088,262.914014 392.44088,264.214014 391.14088,263.714014 L375.34088,260.514014 C373.84088,260.214014 372.54088,258.414014 373.04088,257.014014 L377.54088,234.414014 Z'
                    id='sr48'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M349.94088,225.114014 C350.24088,223.614014 352.34088,222.714014 353.74088,223.114014 L368.74088,228.114014 C370.24088,228.414014 371.14088,230.514014 370.64088,231.814014 L362.94088,253.514014 C362.64088,255.014014 360.54088,255.914014 359.14088,255.514014 L344.14088,250.514014 C342.64088,250.214014 341.74088,248.114014 342.24088,246.814014 L349.94088,225.114014 Z'
                    id='sr50'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M526.24088,278.414014 C526.04088,276.714014 524.34088,275.314014 523.14088,275.614014 L507.24088,276.714014 C505.54088,276.814014 504.24088,278.514014 504.54088,279.714014 L506.94088,302.414014 C507.14088,304.114014 508.84088,305.514014 510.04088,305.214014 L525.94088,304.114014 C527.64088,304.014014 528.94088,302.314014 528.64088,301.114014 L526.24088,278.414014 Z'
                    id='sr3'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M476.74088,306.314014 C476.74088,308.014014 475.24088,309.414014 473.74088,309.314014 L457.54088,309.314014 C455.74088,309.314014 454.34088,307.814014 454.44088,306.314014 L453.94088,283.014014 C453.94088,281.314014 455.44088,279.914014 456.94088,280.014014 L473.14088,280.014014 C474.94088,280.014014 476.34088,281.514014 476.24088,283.014014 L476.74088,306.314014 Z'
                    id='sr1'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M492.34088,266.614014 C492.34088,268.314014 490.84088,269.714014 489.44088,269.714014 L473.24088,269.914014 C471.44088,269.914014 470.04088,268.414014 470.14088,266.914014 L469.44088,243.614014 C469.44088,241.914014 470.94088,240.514014 472.34088,240.514014 L488.54088,240.314014 C490.34088,240.314014 491.74088,241.814014 491.64088,243.314014 L492.34088,266.614014 Z'
                    id='sr5'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M461.94088,267.014014 C461.94088,268.714014 460.34088,270.114014 458.84088,269.914014 L442.64088,269.414014 C440.84088,269.314014 439.54088,267.814014 439.64088,266.314014 L439.84088,243.014014 C439.84088,241.314014 441.44088,239.914014 442.94088,240.114014 L459.14088,240.614014 C460.94088,240.714014 462.24088,242.214014 462.14088,243.714014 L461.94088,267.014014 Z'
                    id='sr2'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M661.94088,220.414014 C660.44088,220.814014 659.44088,222.614014 660.24088,224.314014 L664.44088,239.914014 C664.84088,241.414014 666.54088,242.514014 668.24088,241.614014 L689.94088,235.114014 C691.44088,234.714014 692.44088,232.914014 691.64088,231.214014 L687.44088,216.014014 C687.04088,214.514014 685.34088,213.414014 683.64088,214.314014 L661.94088,220.414014 Z'
                    id='sr7'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M650.64088,196.814014 C649.34088,197.214014 648.44088,199.414014 649.34088,200.714014 L655.84088,215.314014 C656.74088,216.814014 658.44088,217.514014 659.74088,216.614014 L681.14088,207.314014 C682.64088,206.414014 683.34088,204.714014 682.64088,203.214014 L676.14088,188.614014 C675.74088,187.314014 673.54088,186.414014 672.24088,187.314014 L650.64088,196.814014 Z'
                    id='sr9'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M607.74088,141.814014 C606.64088,142.914014 606.64088,144.914014 607.54088,146.014014 L618.64088,158.214014 C619.74088,159.314014 621.64088,159.314014 622.94088,158.414014 L640.04088,142.314014 C641.14088,141.214014 641.14088,139.214014 640.24088,138.114014 L629.14088,125.914014 C628.04088,124.814014 626.14088,124.814014 625.04088,125.714014 L607.74088,141.814014 Z'
                    id='sr11'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M584.54088,124.114014 C583.44088,125.414014 584.14088,127.614014 584.94088,128.214014 L598.04088,137.514014 C599.34088,138.414014 601.44088,137.914014 602.14088,136.614014 L615.44088,117.914014 C616.54088,116.614014 615.84088,114.414014 615.04088,113.814014 L601.94088,104.514014 C600.64088,103.414014 598.54088,104.114014 597.84088,104.914014 L584.54088,124.114014 Z'
                    id='sr13'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M557.34088,108.114014 C556.44088,109.414014 557.14088,111.514014 558.64088,112.114014 L573.34088,119.614014 C574.64088,120.514014 576.94088,119.814014 577.54088,118.314014 L588.44088,97.814014 C589.34088,96.514014 588.64088,94.414014 587.14088,93.814014 L572.44088,86.314014 C571.14088,85.414014 568.84088,86.114014 568.24088,87.614014 L557.34088,108.114014 Z'
                    id='sr15'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M528.04088,98.514014 C527.64088,100.014014 528.24088,101.914014 529.74088,102.414014 L544.94088,106.914014 C546.44088,107.314014 548.44088,106.714014 548.84088,105.214014 L555.74088,83.514014 C556.14088,82.014014 555.54088,80.114014 554.04088,79.614014 L538.84088,75.114014 C537.34088,74.714014 535.34088,75.314014 534.94088,76.814014 L528.04088,98.514014 Z'
                    id='sr17'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M498.94088,94.614014 C498.74088,96.214014 500.04088,98.214014 501.84088,98.214014 L518.44088,100.014014 C520.04088,100.214014 521.54088,98.914014 522.04088,97.114014 L524.94088,73.414014 C525.14088,71.814014 523.84088,69.814014 522.04088,69.814014 L505.44088,68.014014 C503.84088,67.814014 502.34088,69.114014 501.84088,70.914014 L498.94088,94.614014 Z'
                    id='sr19'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M451.94088,94.614014 C452.14088,96.214014 450.84088,98.214014 449.04088,98.214014 L432.44088,100.014014 C430.84088,100.214014 429.34088,98.914014 428.84088,97.114014 L425.94088,73.414014 C425.74088,71.814014 427.04088,69.814014 428.84088,69.814014 L445.44088,68.014014 C447.04088,67.814014 448.54088,69.114014 449.04088,70.914014 L451.94088,94.614014 Z'
                    id='sr16'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M421.84088,98.514014 C422.24088,100.014014 421.64088,101.914014 420.14088,102.414014 L404.94088,106.914014 C403.44088,107.314014 401.44088,106.714014 401.04088,105.214014 L394.14088,83.514014 C393.74088,82.014014 394.34088,80.114014 395.84088,79.614014 L411.04088,75.114014 C412.54088,74.714014 414.54088,75.314014 414.94088,76.814014 L421.84088,98.514014 Z'
                    id='sr14'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M392.54088,108.114014 C393.44088,109.414014 392.74088,111.514014 391.24088,112.114014 L376.54088,119.614014 C375.24088,120.514014 372.94088,119.814014 372.34088,118.314014 L361.44088,97.814014 C360.54088,96.514014 361.24088,94.414014 362.74088,93.814014 L377.44088,86.314014 C378.74088,85.414014 381.04088,86.114014 381.64088,87.614014 L392.54088,108.114014 Z'
                    id='sr12'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M365.34088,123.814014 C366.44088,125.114014 365.94088,127.114014 364.94088,127.914014 L352.14088,137.514014 C350.84088,138.414014 348.94088,138.214014 348.04088,136.814014 L334.54088,118.314014 C333.44088,117.014014 333.94088,115.014014 334.94088,114.214014 L347.74088,104.614014 C349.04088,103.514014 350.94088,103.914014 351.84088,105.014014 L365.34088,123.814014 Z'
                    id='sr10'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M341.04088,141.614014 C342.14088,142.514014 342.34088,144.714014 341.24088,145.814014 L330.44088,158.114014 C329.54088,159.214014 327.44088,159.414014 326.14088,158.314014 L308.84088,142.514014 C307.74088,141.614014 307.54088,139.414014 308.64088,138.314014 L319.44088,126.014014 C320.34088,124.914014 322.44088,124.714014 323.74088,125.814014 L341.04088,141.614014 Z'
                    id='sr8'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M299.24088,196.814014 C300.54088,197.214014 301.44088,199.414014 300.54088,200.714014 L293.94088,215.314014 C293.54088,216.814014 291.34088,217.514014 290.04088,216.614014 L268.54088,207.314014 C267.24088,206.414014 266.34088,204.714014 267.24088,203.214014 L273.84088,188.614014 C274.24088,187.314014 276.44088,186.414014 277.74088,187.314014 L299.24088,196.814014 Z'
                    id='sr6'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M288.94088,220.414014 C290.44088,220.814014 291.44088,222.614014 290.64088,224.314014 L286.44088,239.914014 C286.04088,241.414014 284.34088,242.514014 282.64088,241.614014 L260.94088,235.114014 C259.44088,234.714014 258.44088,232.914014 259.24088,231.214014 L263.44088,216.014014 C263.84088,214.514014 265.54088,213.414014 267.24088,214.314014 L288.94088,220.414014 Z'
                    id='sr4'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M730.24088,220.214014 C728.74088,220.414014 727.44088,221.914014 728.14088,223.714014 L731.74088,238.714014 C731.94088,240.214014 733.44088,241.414014 735.34088,240.814014 L757.54088,235.814014 C759.04088,235.614014 760.34088,234.114014 759.64088,232.314014 L756.04088,217.314014 C755.84088,215.814014 754.34088,214.614014 752.44088,215.214014 L730.24088,220.214014 Z'
                    id='sr21'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M719.94088,190.514014 C718.44088,190.914014 717.34088,192.714014 718.44088,194.514014 L723.94088,209.914014 C724.34088,211.514014 726.14088,212.614014 727.94088,211.714014 L749.94088,203.514014 C751.44088,203.114014 752.54088,201.314014 751.74088,199.514014 L746.24088,184.114014 C745.84088,182.514014 744.04088,181.414014 742.24088,182.314014 L719.94088,190.514014 Z'
                    id='sr23'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M706.34088,163.414014 C705.04088,164.314014 704.64088,166.014014 705.04088,167.514014 L712.54088,181.614014 C713.44088,182.914014 715.14088,183.314014 716.64088,182.914014 L737.24088,172.714014 C738.54088,171.814014 739.34088,170.114014 738.54088,168.614014 L731.04088,154.514014 C730.14088,153.214014 728.44088,152.814014 726.94088,153.214014 L706.34088,163.414014 Z'
                    id='sr25'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M664.84088,108.114014 C663.74088,109.214014 663.54088,111.114014 664.84088,112.214014 L675.74088,124.114014 C676.84088,125.214014 678.74088,125.414014 680.14088,124.114014 L697.14088,108.114014 C698.24088,107.014014 698.44088,105.114014 697.14088,103.814014 L686.24088,91.914014 C685.14088,90.814014 683.24088,90.614014 681.84088,91.914014 L664.84088,108.114014 Z'
                    id='sr27'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M643.64088,88.714014 C642.54088,90.014014 642.84088,92.214014 643.84088,92.814014 L655.84088,103.214014 C657.14088,104.314014 659.24088,104.114014 659.84088,103.014014 L674.24088,85.214014 C675.34088,83.914014 675.04088,81.714014 674.04088,81.114014 L662.04088,70.714014 C660.74088,69.614014 658.64088,69.814014 658.04088,70.914014 L643.64088,88.714014 Z'
                    id='sr29'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M615.34088,70.514014 C614.44088,71.814014 614.94088,74.014014 616.24088,74.614014 L629.64088,83.514014 C630.94088,84.414014 633.14088,83.914014 633.74088,82.614014 L646.44088,63.414014 C647.34088,62.114014 646.84088,59.914014 645.54088,59.314014 L632.14088,50.414014 C630.84088,49.514014 628.64088,50.014014 628.04088,51.314014 L615.34088,70.514014 Z'
                    id='sr31'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M589.24088,56.514014 C588.44088,57.814014 589.24088,59.914014 590.54088,60.614014 L604.64088,67.714014 C605.94088,68.614014 608.04088,67.714014 608.64088,66.414014 L618.54088,45.614014 C619.34088,44.314014 618.54088,42.214014 617.24088,41.514014 L603.14088,34.414014 C601.84088,33.514014 599.74088,34.414014 599.14088,35.714014 L589.24088,56.514014 Z'
                    id='sr33'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M361.64088,56.514014 C362.44088,57.814014 361.64088,59.914014 360.34088,60.614014 L346.24088,67.714014 C344.94088,68.614014 342.84088,67.714014 342.24088,66.414014 L332.34088,45.614014 C331.54088,44.314014 332.34088,42.214014 333.64088,41.514014 L347.74088,34.414014 C349.04088,33.514014 351.14088,34.414014 351.74088,35.714014 L361.64088,56.514014 Z'
                    id='sr30'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M335.54088,69.514014 C336.44088,70.814014 335.94088,73.014014 334.64088,73.614014 L321.24088,82.514014 C319.94088,83.414014 317.74088,82.914014 317.14088,81.614014 L304.44088,62.414014 C303.54088,61.114014 304.04088,58.914014 305.34088,58.314014 L318.74088,49.414014 C320.04088,48.514014 322.24088,49.014014 322.84088,50.314014 L335.54088,69.514014 Z'
                    id='sr28'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M308.24088,86.714014 C309.34088,88.014014 309.04088,90.214014 308.04088,90.814014 L296.04088,101.214014 C294.74088,102.314014 292.64088,102.114014 292.04088,101.014014 L277.64088,83.214014 C276.54088,81.914014 276.84088,79.714014 277.84088,79.114014 L289.84088,68.714014 C291.14088,67.614014 293.24088,67.814014 293.84088,68.914014 L308.24088,86.714014 Z'
                    id='sr26'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M287.04088,108.114014 C288.14088,109.214014 288.34088,111.114014 287.04088,112.214014 L276.14088,124.114014 C275.04088,125.214014 273.14088,125.414014 271.74088,124.114014 L254.74088,108.114014 C253.64088,107.014014 253.44088,105.114014 254.74088,103.814014 L265.64088,91.914014 C266.74088,90.814014 268.64088,90.614014 270.04088,91.914014 L287.04088,108.114014 Z'
                    id='sr24'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M244.54088,163.414014 C245.84088,164.314014 246.24088,166.014014 245.84088,167.514014 L238.34088,181.614014 C237.44088,182.914014 235.74088,183.314014 234.24088,182.914014 L213.64088,172.714014 C212.34088,171.814014 211.54088,170.114014 212.34088,168.614014 L219.84088,154.514014 C220.74088,153.214014 222.44088,152.814014 223.94088,153.214014 L244.54088,163.414014 Z'
                    id='sr22'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M231.84088,189.514014 C233.34088,189.914014 234.54088,191.714014 233.64088,193.514014 L228.14088,208.914014 C227.74088,210.514014 225.94088,211.614014 224.14088,210.714014 L202.04088,202.514014 C200.54088,202.114014 199.34088,200.314014 200.24088,198.514014 L205.74088,183.114014 C206.14088,181.514014 207.94088,180.414014 209.74088,181.314014 L231.84088,189.514014 Z'
                    id='sr20'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M221.64088,218.214014 C223.14088,218.414014 224.44088,219.914014 223.74088,221.714014 L220.14088,236.714014 C219.94088,238.214014 218.44088,239.414014 216.54088,238.814014 L194.34088,233.814014 C192.84088,233.614014 191.54088,232.114014 192.24088,230.314014 L195.84088,215.314014 C196.04088,213.814014 197.54088,212.614014 199.44088,213.214014 L221.64088,218.214014 Z'
                    id='sr18'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M793.64088,215.914014 C792.14088,216.114014 790.74088,217.414014 791.04088,219.414014 L793.64088,235.414014 C793.84088,236.914014 795.14088,238.214014 797.14088,238.014014 L820.24088,234.314014 C821.74088,234.114014 823.14088,232.814014 822.84088,230.614014 L820.24088,214.614014 C820.04088,213.114014 818.44088,211.814014 816.74088,212.014014 L793.64088,215.914014 Z'
                    id='sr35'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M787.14088,187.114014 C785.64088,187.514014 784.54088,189.314014 785.04088,190.914014 L789.14088,206.814014 C789.54088,208.314014 791.24088,209.414014 792.74088,209.014014 L814.74088,203.014014 C816.24088,202.614014 817.34088,200.814014 816.84088,199.214014 L812.74088,183.314014 C812.34088,181.814014 810.64088,180.714014 809.14088,181.114014 L787.14088,187.114014 Z'
                    id='sr37'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M774.74088,156.914014 C773.14088,157.314014 772.54088,159.614014 773.14088,160.914014 L779.14088,176.214014 C779.54088,177.814014 781.84088,178.414014 783.14088,177.814014 L805.14088,169.214014 C806.74088,168.814014 807.34088,166.514014 806.74088,165.214014 L800.74088,149.914014 C800.34088,148.314014 798.04088,147.714014 796.74088,148.314014 L774.74088,156.914014 Z'
                    id='sr39'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M760.34088,129.114014 C759.04088,130.014014 758.64088,132.014014 759.24088,133.314014 L767.04088,147.514014 C767.94088,148.814014 769.84088,149.314014 771.14088,148.614014 L791.54088,136.814014 C792.84088,135.914014 793.24088,133.914014 792.64088,132.614014 L784.84088,118.414014 C783.94088,117.114014 782.04088,116.614014 780.74088,117.314014 L760.34088,129.114014 Z'
                    id='sr41'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M735.34088,58.714014 C736.44088,57.614014 738.34088,57.814014 739.44088,58.914014 L750.14088,71.414014 C751.24088,72.514014 751.24088,74.514014 749.94088,75.614014 L732.54088,91.214014 C731.44088,92.314014 729.54088,92.314014 728.44088,91.014014 L717.74088,78.514014 C716.64088,77.414014 716.64088,75.414014 717.94088,74.314014 L735.34088,58.714014 Z'
                    id='sr43'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M709.24088,35.014014 C710.34088,33.714014 712.54088,33.714014 713.34088,34.814014 L724.94088,46.114014 C726.24088,47.214014 726.24088,49.414014 725.14088,50.214014 L709.04088,67.014014 C707.94088,68.314014 705.74088,68.314014 704.94088,67.214014 L692.94088,55.914014 C691.64088,54.814014 691.64088,52.614014 692.74088,51.814014 L709.24088,35.014014 Z'
                    id='sr45'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M682.44088,13.114014 C683.24088,11.814014 685.14088,11.614014 686.44088,12.714014 L698.84088,22.414014 C700.14088,23.314014 700.34088,25.214014 699.24088,26.514014 L685.34088,44.914014 C684.54088,46.214014 682.64088,46.414014 681.34088,45.314014 L668.94088,35.614014 C667.64088,34.714014 667.44088,32.814014 668.54088,31.514014 L682.44088,13.114014 Z'
                    id='sr47'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M280.24088,31.514014 C281.24088,32.814014 281.04088,35.014014 279.84088,35.614014 L267.44088,45.314014 C266.14088,46.414014 264.04088,46.214014 263.44088,44.914014 L249.54088,26.514014 C248.54088,25.214014 248.74088,23.014014 249.94088,22.414014 L262.34088,12.714014 C263.64088,11.614014 265.74088,11.814014 266.34088,13.114014 L280.24088,31.514014 Z'
                    id='sr44'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M256.14088,50.814014 C257.24088,51.914014 257.24088,53.814014 255.94088,54.914014 L243.94088,66.214014 C242.84088,67.314014 240.94088,67.314014 239.84088,66.014014 L223.74088,49.214014 C222.64088,48.114014 222.64088,46.214014 223.94088,45.114014 L235.44088,33.814014 C236.54088,32.714014 238.44088,32.714014 239.54088,34.014014 L256.14088,50.814014 Z'
                    id='sr42'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M232.94088,73.314014 C234.24088,74.414014 234.24088,76.414014 233.14088,77.514014 L222.44088,90.014014 C221.34088,91.314014 219.44088,91.314014 218.34088,90.214014 L200.94088,74.614014 C199.64088,73.514014 199.64088,71.514014 200.74088,70.414014 L211.44088,58.014014 C212.54088,56.914014 214.44088,56.714014 215.54088,57.814014 L232.94088,73.314014 Z'
                    id='sr40'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M190.54088,129.114014 C191.84088,130.014014 192.24088,132.014014 191.64088,133.314014 L183.84088,147.514014 C182.94088,148.814014 181.04088,149.314014 179.74088,148.614014 L159.34088,136.814014 C158.04088,135.914014 157.64088,133.914014 158.24088,132.614014 L166.04088,118.414014 C166.94088,117.114014 168.84088,116.614014 170.14088,117.314014 L190.54088,129.114014 Z'
                    id='sr38'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M176.14088,156.914014 C177.74088,157.314014 178.34088,159.614014 177.74088,160.914014 L171.74088,176.214014 C171.34088,177.814014 169.04088,178.414014 167.74088,177.814014 L145.74088,169.214014 C144.14088,168.814014 143.54088,166.514014 144.14088,165.214014 L150.14088,149.914014 C150.54088,148.314014 152.84088,147.714014 154.14088,148.314014 L176.14088,156.914014 Z'
                    id='sr36'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M163.74088,187.114014 C165.24088,187.514014 166.34088,189.314014 165.84088,190.914014 L161.74088,206.814014 C161.34088,208.314014 159.64088,209.414014 158.14088,209.014014 L136.14088,203.014014 C134.64088,202.614014 133.54088,200.814014 134.04088,199.214014 L138.14088,183.314014 C138.54088,181.814014 140.24088,180.714014 141.74088,181.114014 L163.74088,187.114014 Z'
                    id='sr34'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  <path
                    d='M157.24088,215.914014 C158.74088,216.114014 160.14088,217.414014 159.84088,219.414014 L157.24088,235.414014 C157.04088,236.914014 155.74088,238.214014 153.74088,238.014014 L130.64088,234.314014 C129.14088,234.114014 127.74088,232.814014 128.04088,230.614014 L130.64088,214.614014 C130.84088,213.114014 132.44088,211.814014 134.14088,212.014014 L157.24088,215.914014 Z'
                    id='sr32'
                    fill='#DDDDDD'
                    fillRule='nonzero'
                  />
                  {isMobile && council === 'sr' && (
                    <circle
                      id='srcircle'
                      cx={this.state.touchPos.x}
                      cy={this.state.touchPos.y}
                      r={this.state.circleRadius}
                      stroke='#282828'
                      strokeWidth={5}
                      fill='red'
                    />
                  )}
                </g>
              </svg>
            </div>
            <ListComponent
              council={council}
              data={council === 'nr' ? this.props.nr : this.props.sr}
              update={isMobile ? latestTouch : null}
              hasFilter={!this.state.filterIsActive}
            />
          </div>
        )}
        {this.state.showOverlay && (
          <OverlayComponent
            council={this.props.council}
            closeHandler={() => {
              this.setState({
                showOverlay: false,
                showTooltip: this.state.textFilterIsActive
              })
              this.freezeBody(false)
            }}
            currentPolitician={currentPolitician}
            escapeName={this.escapeName}
            politicianHandler={this.politicianHandler}
          />
        )}
      </div>
    )
  }
}
SVGComponent.contextType = LocaleContext
